import './index.css';var Ut = Object.defineProperty;
var Kt = (r, e, t) => e in r ? Ut(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var I = (r, e, t) => Kt(r, typeof e != "symbol" ? e + "" : e, t);
import { jsxs as F, jsx as p, Fragment as J } from "react/jsx-runtime";
import { Button as M, Tooltip as Yt, Modal as _t, Field as ge, Input as Re, Textarea as Wt, Collapse as Ge, Radio as Fe, Select as Xt, RadioButtonGroup as Tt, Checkbox as Zt, Scrollbar as Jt } from "@repo/go-ui";
import { hasValue as W, getWellStatusColor as qt, equalsDeep as Qt } from "@repo/utils";
import { observer as L } from "mobx-react-lite";
import { useState as ie, useMemo as Pe, useEffect as Me } from "react";
import { useTranslation as N, initReactI18next as en, I18nextProvider as tn } from "react-i18next";
import { ExpandUpLight as Ct, ExpandDownLight as Ft, BookmarkFill as nn, BookmarkLight as rn, DotsEditCustom as ln, CloseMiniLine as xt, DoneLight as kt, FilterAltLight as sn, ExportLight as on, ArhiveAltExportLight as an, CloseRoundLight as cn, SearchLight as dn, VerticalCustom as pn, CheckRingLight as un } from "@repo/go-icons";
import { action as y, makeObservable as Se, reaction as Ae, observable as T, computed as w, flow as U, runInAction as K } from "mobx";
import hn from "i18next";
function Pt(r) {
  var e, t, n = "";
  if (typeof r == "string" || typeof r == "number") n += r;
  else if (typeof r == "object") if (Array.isArray(r)) {
    var i = r.length;
    for (e = 0; e < i; e++) r[e] && (t = Pt(r[e])) && (n && (n += " "), n += t);
  } else for (t in r) r[t] && (n && (n += " "), n += t);
  return n;
}
function D() {
  for (var r, e, t = 0, n = "", i = arguments.length; t < i; t++) (r = arguments[t]) && (e = Pt(r)) && (n && (n += " "), n += e);
  return n;
}
const fn = {
  status: [],
  workStartDateFrom: null,
  workStartDateTo: null,
  organizationId: [],
  blockId: [],
  fieldId: [],
  padId: [],
  wellId: [],
  rigModelId: [],
  brigadeId: [],
  wellboreTypeInstanceId: []
}, Dt = 2, te = {
  showFact: !0,
  showPlan: !0,
  showWellbores: !0,
  showTrajectories: !0
}, mn = { wells: [] };
function oe(r) {
  if (r.length === 0)
    return "unchecked";
  let e = !1, t = !1, n = !1;
  for (const i of r)
    i === "checked" ? e = !0 : i === "unchecked" ? t = !0 : n = !0;
  return n || e && t ? "intermediate" : e ? "checked" : "unchecked";
}
function bn(r, e) {
  return r.wells.find((t) => t.wellId === e);
}
function Et(r, e) {
  return r == null ? void 0 : r.find((t) => t.wellboreId === e);
}
function gn(r, e) {
  return r == null ? void 0 : r.find((t) => t.designId === e);
}
function ye(r, e, t, n = !0) {
  const i = Et(r, e);
  if (!i) return "unchecked";
  if (!n || i.trajectories.length === 0 || !t || t.length === 0)
    return "checked";
  const l = new Set(i.trajectories.map((o) => o.trajectoryId)), s = t.map((o) => l.has(o) ? "checked" : "unchecked");
  return oe(s);
}
function yn(r, e, t) {
  const n = Et(r, e);
  return n && (n.trajectories.length === 0 || n.trajectories.some((i) => i.trajectoryId === t)) ? "checked" : "unchecked";
}
function Le(r, e, t, n = !0, i = !0) {
  const l = gn(r, e);
  if (!l) return "unchecked";
  if (!i || l.wellbores.length === 0 || !t || t.length === 0)
    return "checked";
  const s = t.map(
    (o) => ye(
      l.wellbores,
      o.id,
      o.trajectories.map((a) => a.id),
      n
    )
  );
  return oe(s);
}
function Be(r, e, t = te) {
  if (!t.showFact || !r || r.fact === void 0)
    return "unchecked";
  if (r.fact.length === 0 || !t.showWellbores)
    return "checked";
  const n = e == null ? void 0 : e.factWellbores;
  if (!n || n.length === 0)
    return "checked";
  const i = n.map(
    (l) => ye(
      r.fact,
      l.id,
      l.trajectories.map((s) => s.id),
      t.showTrajectories
    )
  );
  return oe(i);
}
function Oe(r, e, t = te) {
  if (!t.showPlan || !r || r.plan === void 0)
    return "unchecked";
  if (r.plan.length === 0)
    return "checked";
  const n = e == null ? void 0 : e.planDesigns;
  if (!n || n.length === 0)
    return "checked";
  const i = n.map(
    (l) => Le(r.plan, l.id, l.wellbores, t.showTrajectories, t.showWellbores)
  );
  return oe(i);
}
function $e(r, e, t, n = te) {
  const i = bn(r, e);
  if (!i) return "unchecked";
  const l = [];
  return n.showFact && l.push(Be(i, t, n)), n.showPlan && l.push(Oe(i, t, n)), l.length === 0 ? "checked" : oe(l);
}
function In(r, e, t, n = te) {
  if (e.length === 0)
    return "unchecked";
  const i = e.map((l) => $e(r, l, t == null ? void 0 : t(l), n));
  return oe(i);
}
function B(r) {
  return r === "checked";
}
function q(r) {
  return r === "intermediate";
}
function le(r) {
  return r !== "unchecked";
}
function Ve(r) {
  return !r || !Array.isArray(r.wells) ? { wells: [] } : { wells: r.wells };
}
function j(r) {
  return structuredClone(Ve(r));
}
function Ie() {
  return j(mn);
}
function ue(r) {
  return r ? {
    status: [...r.status],
    workStartDateFrom: r.workStartDateFrom,
    workStartDateTo: r.workStartDateTo,
    organizationId: [...r.organizationId],
    blockId: [...r.blockId],
    fieldId: [...r.fieldId],
    padId: [...r.padId],
    wellId: [...r.wellId],
    rigModelId: [...r.rigModelId],
    brigadeId: [...r.brigadeId],
    wellboreTypeInstanceId: [...r.wellboreTypeInstanceId]
  } : null;
}
function Y(r) {
  return Array.isArray(r) && r.every((e) => typeof e == "string" || typeof e == "number");
}
function vn(r) {
  if (r == null || !r || typeof r != "object")
    return null;
  const e = r, t = fn;
  return {
    status: Array.isArray(e.status) ? e.status.filter((n) => typeof n == "string") : [...t.status],
    workStartDateFrom: typeof e.workStartDateFrom == "number" ? e.workStartDateFrom : null,
    workStartDateTo: typeof e.workStartDateTo == "number" ? e.workStartDateTo : null,
    organizationId: Y(e.organizationId) ? [...e.organizationId] : [...t.organizationId],
    blockId: Y(e.blockId) ? [...e.blockId] : [...t.blockId],
    fieldId: Y(e.fieldId) ? [...e.fieldId] : [...t.fieldId],
    padId: Y(e.padId) ? [...e.padId] : [...t.padId],
    wellId: Y(e.wellId) ? [...e.wellId] : [...t.wellId],
    rigModelId: Y(e.rigModelId) ? [...e.rigModelId] : [...t.rigModelId],
    brigadeId: Y(e.brigadeId) ? [...e.brigadeId] : [...t.brigadeId],
    wellboreTypeInstanceId: Y(e.wellboreTypeInstanceId) ? [...e.wellboreTypeInstanceId] : [...t.wellboreTypeInstanceId]
  };
}
function he(r) {
  return r ? r.status.length === 0 && r.workStartDateFrom === null && r.workStartDateTo === null && r.organizationId.length === 0 && r.blockId.length === 0 && r.fieldId.length === 0 && r.padId.length === 0 && r.wellId.length === 0 && r.rigModelId.length === 0 && r.brigadeId.length === 0 && r.wellboreTypeInstanceId.length === 0 : !0;
}
function fe(r, e = null) {
  return {
    schemaVersion: Dt,
    tree: j(r),
    filters: ue(e)
  };
}
function me(r) {
  var t;
  if (!r || typeof r != "object")
    return {
      tree: Ie(),
      filters: null
    };
  const e = r;
  return e.schemaVersion === 1 ? {
    tree: j(e.tree),
    filters: null
  } : e.schemaVersion === Dt ? {
    tree: j(e.tree),
    filters: vn((t = e.filters) != null ? t : null)
  } : {
    tree: Ie(),
    filters: null
  };
}
function yl(r) {
  return me(r).tree;
}
function Gt(r, e, t) {
  return e ? {
    wellboreId: r.wellboreId,
    trajectories: r.trajectories.map((n) => ({ trajectoryId: n.trajectoryId }))
  } : B(
    ye([r], r.wellboreId, t, !0)
  ) ? { wellboreId: r.wellboreId, trajectories: [] } : null;
}
function Sn(r, e, t) {
  var i;
  if (r.wellbores.length === 0)
    return { designId: r.designId, wellbores: [] };
  const n = [];
  for (const l of r.wellbores) {
    const s = (i = t == null ? void 0 : t.find((a) => a.id === l.wellboreId)) == null ? void 0 : i.trajectories.map((a) => a.id), o = Gt(l, e, s);
    o && n.push(o);
  }
  return n.length === 0 ? B(Le([r], r.designId, t, !0)) ? { designId: r.designId, wellbores: [] } : null : { designId: r.designId, wellbores: n };
}
function wn(r, e, t) {
  var i, l;
  const n = { wellId: r.wellId };
  if (t.showFact && r.fact !== void 0)
    if (r.fact.length === 0)
      n.fact = [];
    else {
      const s = [];
      for (const o of r.fact) {
        const a = (i = e == null ? void 0 : e.factWellbores.find((u) => u.id === o.wellboreId)) == null ? void 0 : i.trajectories.map((u) => u.id), c = Gt(o, t.showTrajectories, a);
        c && s.push(c);
      }
      s.length > 0 && (n.fact = s);
    }
  if (t.showPlan && r.plan !== void 0)
    if (r.plan.length === 0)
      n.plan = [];
    else {
      const s = [];
      for (const o of r.plan) {
        const a = (l = e == null ? void 0 : e.planDesigns.find((u) => u.id === o.designId)) == null ? void 0 : l.wellbores, c = Sn(o, t.showTrajectories, a);
        c && s.push(c);
      }
      s.length > 0 && (n.plan = s);
    }
  return n.fact === void 0 && n.plan === void 0 ? !t.showFact && !t.showPlan ? n : null : n;
}
function At(r, e, t = te) {
  const n = Ve(r), i = [];
  for (const l of n.wells) {
    const s = wn(l, e(l.wellId), t);
    s && i.push(s);
  }
  return { wells: i };
}
function be(r, e) {
  return r.trajectories.length > 0 ? {
    wellboreId: r.wellboreId,
    trajectories: r.trajectories.map((t) => ({ trajectoryId: t.trajectoryId }))
  } : {
    wellboreId: r.wellboreId,
    trajectories: e.map((t) => ({ trajectoryId: t }))
  };
}
function _n(r, e) {
  var n;
  const t = (n = e == null ? void 0 : e.factWellbores) != null ? n : [];
  return r.length === 0 ? t.map(
    (i) => be(
      { wellboreId: i.id, trajectories: [] },
      i.trajectories.map((l) => l.id)
    )
  ) : r.map((i) => {
    var s, o;
    const l = (o = (s = t.find((a) => a.id === i.wellboreId)) == null ? void 0 : s.trajectories.map((a) => a.id)) != null ? o : [];
    return be(i, l);
  });
}
function Wn(r, e) {
  var n;
  const t = (n = e == null ? void 0 : e.planDesigns) != null ? n : [];
  return r.length === 0 ? t.map((i) => ({
    designId: i.id,
    wellbores: i.wellbores.map(
      (l) => be(
        { wellboreId: l.id, trajectories: [] },
        l.trajectories.map((s) => s.id)
      )
    )
  })) : r.map((i) => {
    var o;
    const l = t.find((a) => a.id === i.designId), s = (o = l == null ? void 0 : l.wellbores) != null ? o : [];
    return i.wellbores.length === 0 ? {
      designId: i.designId,
      wellbores: s.map(
        (a) => be(
          { wellboreId: a.id, trajectories: [] },
          a.trajectories.map((c) => c.id)
        )
      )
    } : {
      designId: i.designId,
      wellbores: i.wellbores.map((a) => {
        var u, d;
        const c = (d = (u = s.find((h) => h.id === a.wellboreId)) == null ? void 0 : u.trajectories.map((h) => h.id)) != null ? d : [];
        return be(a, c);
      })
    };
  });
}
function Tn(r, e, t = te) {
  const n = Ve(r), i = [];
  for (const l of n.wells) {
    const s = e(l.wellId), o = { wellId: l.wellId };
    t.showFact && l.fact !== void 0 && (o.fact = _n(l.fact, s)), t.showPlan && l.plan !== void 0 && (o.plan = Wn(l.plan, s)), !(o.fact === void 0 && o.plan === void 0) && i.push(o);
  }
  return { wells: i };
}
const Cn = "applied-filters-section-module__root__OTZuV", Fn = "applied-filters-section-module__header__V9LXK", xn = "applied-filters-section-module__expandIcon__cvZnP", kn = "applied-filters-section-module__title__opcif", Pn = "applied-filters-section-module__chips__oocac", Dn = "applied-filters-section-module__chip__pkpuw", Q = {
  root: Cn,
  header: Fn,
  expandIcon: xn,
  title: kn,
  chips: Pn,
  chip: Dn
};
function En(r) {
  const e = typeof r == "number" ? r : Number(r);
  return Number.isFinite(e) ? e : null;
}
function Ze(r) {
  try {
    return new Date(r * 1e3).toLocaleDateString();
  } catch {
    return String(r);
  }
}
function Gn(r, e) {
  var n, i, l, s, o, a, c, u, d, h, m, f, S, _;
  const t = {
    organizationId: /* @__PURE__ */ new Map(),
    blockId: /* @__PURE__ */ new Map(),
    fieldId: /* @__PURE__ */ new Map(),
    padId: /* @__PURE__ */ new Map(),
    wellId: /* @__PURE__ */ new Map(),
    rigModelId: /* @__PURE__ */ new Map(),
    brigadeId: /* @__PURE__ */ new Map(),
    wellboreTypeInstanceId: /* @__PURE__ */ new Map()
  };
  for (const v of r) {
    t.wellId.set(v.id, v.name), ((n = v.organization) == null ? void 0 : n.id) != null && v.organization.name && t.organizationId.set(v.organization.id, v.organization.name), ((i = v.block) == null ? void 0 : i.organizationId) != null && ((l = v.organization) != null && l.name) && t.organizationId.set(v.block.organizationId, v.organization.name), ((s = v.block) == null ? void 0 : s.id) != null && v.block.name && t.blockId.set(v.block.id, v.block.name), ((o = v.field) == null ? void 0 : o.id) != null && v.field.name && t.fieldId.set(v.field.id, v.field.name);
    const R = (c = v.padId) != null ? c : (a = v.pad) == null ? void 0 : a.id, O = (h = (u = v.pad) == null ? void 0 : u.abbreviatedName) != null ? h : (d = v.pad) == null ? void 0 : d.name;
    R != null && O && t.padId.set(R, O), ((m = v.rigModel) == null ? void 0 : m.id) != null && v.rigModel.name && t.rigModelId.set(v.rigModel.id, v.rigModel.name);
    const ne = (S = v.brigadeId) != null ? S : (f = v.brigade) == null ? void 0 : f.id, E = (_ = v.brigade) == null ? void 0 : _.name;
    ne != null && E && t.brigadeId.set(ne, E);
    const ae = e(v.id);
    if (ae) {
      for (const re of ae.factWellbores)
        re.typeInstanceId != null && re.typeInstanceName && t.wellboreTypeInstanceId.set(re.typeInstanceId, re.typeInstanceName);
      for (const re of ae.planDesigns)
        for (const we of re.wellbores)
          we.typeInstanceId != null && we.typeInstanceName && t.wellboreTypeInstanceId.set(we.typeInstanceId, we.typeInstanceName);
    }
  }
  return t;
}
function An(r, e) {
  var n;
  const t = En(r);
  return t == null ? String(r) : (n = e.get(t)) != null ? n : String(r);
}
function jn(r, e, t) {
  if (!r || he(r))
    return [];
  const n = [];
  for (const l of r.status) {
    const s = l.toString().toUpperCase(), o = s === "ACTIVE" || s === "ACTIVE_GREEN" || s === "ACTIVE_YELLOW" || s === "ACTIVE_RED" ? t("Filters.statusActive") : s === "COMPLETED" ? t("Filters.statusCompleted") : String(l);
    n.push({ id: `status:${l}`, label: o });
  }
  r.workStartDateFrom !== null && n.push({ id: "workStartDateFrom", label: Ze(r.workStartDateFrom) }), r.workStartDateTo !== null && n.push({ id: "workStartDateTo", label: Ze(r.workStartDateTo) });
  const i = [
    "organizationId",
    "blockId",
    "fieldId",
    "padId",
    "wellId",
    "rigModelId",
    "brigadeId",
    "wellboreTypeInstanceId"
  ];
  for (const l of i)
    for (const s of r[l])
      n.push({
        id: `${l}:${s}`,
        label: An(s, e[l])
      });
  return n;
}
const Nn = L(function({ store: e }) {
  const { t } = N(), [n, i] = ie(!0), l = Gn(e.wellsSourceAllWells, (o) => e.getWellChildren(o)), s = jn(e.filters, l, t);
  return s.length === 0 ? null : /* @__PURE__ */ F("section", { className: Q.root, children: [
    /* @__PURE__ */ F(
      "button",
      {
        type: "button",
        className: Q.header,
        "aria-expanded": n,
        onClick: () => i((o) => !o),
        children: [
          n ? /* @__PURE__ */ p(Ct, { className: Q.expandIcon }) : /* @__PURE__ */ p(Ft, { className: Q.expandIcon }),
          /* @__PURE__ */ p("span", { className: D("dash-body-bold", Q.title), children: t("Filters.title") })
        ]
      }
    ),
    n && /* @__PURE__ */ p("div", { className: Q.chips, children: s.map((o) => /* @__PURE__ */ p("span", { className: D("dash-body-medium", Q.chip), children: o.label }, o.id)) })
  ] });
}), Rn = "group-action-list-module__list__KVSHC", Mn = "group-action-list-module__listItem__2jJ3J", Ln = "group-action-list-module__listItemRegular__dQCDt", Bn = "group-action-list-module__listItemDangerous__hbMiN", On = "group-action-list-module__listItemDisabled__LOW51", ce = {
  list: Rn,
  listItem: Mn,
  listItemRegular: Ln,
  listItemDangerous: Bn,
  listItemDisabled: On
};
function $n({ actions: r }) {
  return /* @__PURE__ */ p("div", { className: D("dash-body-regular", ce.list), children: r.map(
    (e) => e && /* @__PURE__ */ p(
      "div",
      {
        className: D(
          ce.listItem,
          e.variant === "dangerous" ? ce.listItemDangerous : ce.listItemRegular,
          e.disabled && ce.listItemDisabled
        ),
        onClick: e.disabled ? void 0 : e.onClick,
        children: e.title
      },
      e.id
    )
  ) });
}
const Vn = "group-item-module__item__n8jHb", zn = "group-item-module__itemActive__WbuDd", Hn = "group-item-module__name__iY5-P", Un = "group-item-module__menuButton__waoDQ", Kn = "group-item-module__favoriteButton__uN6-t", Yn = "group-item-module__favoriteIcon__xA3r3", Xn = "group-item-module__favoriteIconActive__mTBWP", Zn = "group-item-module__menuIcon__2Wqf1", X = {
  item: Vn,
  itemActive: zn,
  name: Hn,
  menuButton: Un,
  favoriteButton: Kn,
  favoriteIcon: Yn,
  favoriteIconActive: Xn,
  menuIcon: Zn
}, Je = L(function({ group: e, templatesStore: t, isActive: n = !1 }) {
  const { t: i } = N(), [l, s] = ie(!1), o = e.visibility === "personal", a = Pe(
    () => [
      {
        id: 0,
        title: i("GroupActions.apply"),
        onClick: () => {
          t.applyGroup(e.id, e.visibility), s(!1);
        }
      },
      {
        id: 1,
        title: i("GroupActions.rename"),
        onClick: () => {
          t.openRenameModal(e), s(!1);
        }
      },
      {
        id: 2,
        title: i(o ? "GroupActions.copyToPublic" : "GroupActions.copyToPersonal"),
        onClick: () => {
          t.duplicateGroup(e.id, e.visibility), s(!1);
        }
      },
      {
        id: 3,
        title: i("GroupActions.delete"),
        variant: "dangerous",
        onClick: () => {
          t.deleteGroup(e.id, e.visibility), s(!1);
        }
      }
    ],
    [e, o, i, t]
  ), c = (u) => {
    u.stopPropagation(), t.toggleGroupFavorite(e.id);
  };
  return /* @__PURE__ */ F("div", { className: D(X.item, n && X.itemActive), children: [
    /* @__PURE__ */ p(
      M,
      {
        type: "button",
        variant: "flat",
        size: "s",
        className: D("dash-body-regular", X.name),
        title: e.name,
        onClick: () => t.applyGroup(e.id, e.visibility),
        children: e.name
      }
    ),
    /* @__PURE__ */ p(
      M,
      {
        type: "button",
        variant: "flat",
        size: "s",
        className: X.favoriteButton,
        title: i(e.isFavorite ? "GroupActions.removeFavorite" : "GroupActions.addFavorite"),
        icon: e.isFavorite ? /* @__PURE__ */ p(nn, { className: X.favoriteIconActive }) : /* @__PURE__ */ p(rn, { className: X.favoriteIcon }),
        onClick: c
      }
    ),
    /* @__PURE__ */ p(
      Yt,
      {
        placement: "bottom-end",
        title: /* @__PURE__ */ p($n, { actions: a }),
        trigger: ["click"],
        open: l,
        onOpenChange: s,
        style: { paddingLeft: 0, paddingRight: 0 },
        withArrow: !1,
        children: /* @__PURE__ */ p(
          M,
          {
            type: "button",
            variant: "flat",
            size: "s",
            className: X.menuButton,
            title: i("GroupActions.menu"),
            icon: /* @__PURE__ */ p(ln, { className: X.menuIcon })
          }
        )
      }
    )
  ] });
}), Jn = "groups-tab-module__root__Jw7bf", qn = "groups-tab-module__list__1fwo2", Qn = "groups-tab-module__empty__0jeFG", de = {
  root: Jn,
  list: qn,
  empty: Qn
}, Il = "GOdashboard_ReferenceDataTemplates", jt = 40, Nt = 500, er = "group-form-modal-module__body__-cyp0", tr = "group-form-modal-module__modeRadios__Yr1-Z", nr = "group-form-modal-module__radioRow__BXDbL", rr = "group-form-modal-module__actions__wAccO", ee = {
  body: er,
  modeRadios: tr,
  radioRow: nr,
  actions: rr
}, ir = L(function({ templatesStore: e }) {
  const { t } = N(), n = e.renameTarget, [i, l] = ie(""), [s, o] = ie("");
  Me(() => {
    var c, u;
    l((c = n == null ? void 0 : n.name) != null ? c : ""), o((u = n == null ? void 0 : n.description) != null ? u : "");
  }, [n]);
  const a = i.trim().length > 0 && !e.isSaving;
  return /* @__PURE__ */ p(
    _t,
    {
      open: W(n),
      title: t("RenameModal.title"),
      onClose: e.closeRenameModal,
      style: { width: 440 },
      children: /* @__PURE__ */ F("div", { className: ee.body, children: [
        /* @__PURE__ */ p(ge, { label: t("GroupForm.name"), children: /* @__PURE__ */ p(
          Re,
          {
            value: i,
            maxLength: jt,
            disabled: e.isSaving,
            placeholder: t("GroupForm.namePlaceholder"),
            onChange: (c) => l(c.target.value)
          }
        ) }),
        /* @__PURE__ */ p(ge, { label: t("GroupForm.description"), children: /* @__PURE__ */ p(
          Wt,
          {
            value: s,
            maxLength: Nt,
            minRows: 1,
            maxRows: 5,
            disabled: e.isSaving,
            placeholder: t("GroupForm.descriptionPlaceholder"),
            style: { width: "100%", maxWidth: "100%" },
            onChange: o
          }
        ) }),
        /* @__PURE__ */ F("div", { className: ee.actions, children: [
          /* @__PURE__ */ p(
            M,
            {
              variant: "danger",
              icon: /* @__PURE__ */ p(xt, {}),
              disabled: e.isSaving,
              onClick: e.closeRenameModal,
              children: t("GroupForm.cancel")
            }
          ),
          /* @__PURE__ */ p(
            M,
            {
              variant: "success",
              icon: /* @__PURE__ */ p(kt, {}),
              loading: e.isSaving,
              disabled: !a || !W(n),
              onClick: () => {
                W(n) && e.renameGroup(n.id, n.visibility, i, s);
              },
              children: t("GroupForm.save")
            }
          )
        ] })
      ] })
    }
  );
}), qe = {
  "--go-collapse-body-padding-right": 0,
  "--go-collapse-body-padding-left": 0,
  "--go-collapse-body-padding-top": "4px",
  "--go-collapse-body-padding-bottom": "8px"
}, lr = L(function({ templatesStore: e }) {
  const { t } = N(), { publicGroups: n, personalGroups: i, lastAppliedTemplateId: l, isLoading: s } = e;
  return /* @__PURE__ */ F("div", { className: de.root, children: [
    /* @__PURE__ */ p("div", { className: de.list, children: s ? /* @__PURE__ */ p("p", { className: D("dash-body-regular", de.empty), children: t("Groups.loading") }) : /* @__PURE__ */ F(Ge, { defaultValue: ["Public", "Personal"], children: [
      /* @__PURE__ */ p(
        Ge.Panel,
        {
          header: t("Groups.public"),
          panelKey: "Public",
          styleWrapper: qe,
          stickyHeader: !0,
          children: n.length === 0 ? /* @__PURE__ */ p("p", { className: D("dash-body-regular", de.empty), children: t("Groups.empty") }) : n.map((o) => /* @__PURE__ */ p(
            Je,
            {
              group: o,
              templatesStore: e,
              isActive: l === o.id
            },
            o.id
          ))
        },
        "Public"
      ),
      /* @__PURE__ */ p(
        Ge.Panel,
        {
          header: t("Groups.personal"),
          panelKey: "Personal",
          styleWrapper: qe,
          stickyHeader: !0,
          children: i.length === 0 ? /* @__PURE__ */ p("p", { className: D("dash-body-regular", de.empty), children: t("Groups.empty") }) : i.map((o) => /* @__PURE__ */ p(
            Je,
            {
              group: o,
              templatesStore: e,
              isActive: l === o.id
            },
            o.id
          ))
        },
        "Personal"
      )
    ] }) }),
    /* @__PURE__ */ p(ir, { templatesStore: e })
  ] });
}), sr = "panel-footer-module__footer__BwXU9", or = "panel-footer-module__selectionActions__ehWmp", ar = "panel-footer-module__selectionButton__PXkJS", cr = "panel-footer-module__saveButton__ZYZR2", dr = "panel-footer-module__icon__O8bIw", $ = {
  footer: sr,
  selectionActions: or,
  selectionButton: ar,
  saveButton: cr,
  icon: dr
}, pr = L(function({ store: e }) {
  var n;
  const { t } = N();
  return /* @__PURE__ */ F(J, { children: [
    /* @__PURE__ */ F("div", { className: ee.radioRow, children: [
      /* @__PURE__ */ p(
        Fe,
        {
          id: "ref-save-existing-personal",
          name: "ref-save-existing-visibility-personal",
          value: "personal",
          checked: e.existingVisibility === "personal",
          disabled: e.isSaving || e.personalDisabled,
          onChange: () => e.setExistingVisibility("personal"),
          children: t("SaveModal.personal")
        }
      ),
      /* @__PURE__ */ p(
        Fe,
        {
          id: "ref-save-existing-public",
          name: "ref-save-existing-visibility-public",
          value: "public",
          checked: e.existingVisibility === "public",
          disabled: e.isSaving || e.publicDisabled,
          onChange: () => e.setExistingVisibility("public"),
          children: t("SaveModal.public")
        }
      )
    ] }),
    /* @__PURE__ */ p(ge, { label: t("SaveModal.group"), children: /* @__PURE__ */ p(
      Xt,
      {
        value: (n = e.selectedGroupId) != null ? n : void 0,
        disabled: e.isExistingSelectDisabled,
        placeholder: t("SaveModal.groupPlaceholder"),
        options: e.existingOptions,
        onChange: e.onSelectedGroupChange
      }
    ) })
  ] });
}), ur = L(function({ store: e }) {
  const { t } = N();
  return /* @__PURE__ */ F(J, { children: [
    /* @__PURE__ */ F("div", { className: ee.radioRow, children: [
      /* @__PURE__ */ p(
        Fe,
        {
          id: "ref-save-new-personal",
          name: "ref-save-new-visibility-personal",
          value: "personal",
          checked: e.newVisibility === "personal",
          disabled: e.isSaving,
          onChange: () => e.setNewVisibility("personal"),
          children: t("SaveModal.personal")
        }
      ),
      /* @__PURE__ */ p(
        Fe,
        {
          id: "ref-save-new-public",
          name: "ref-save-new-visibility-public",
          value: "public",
          checked: e.newVisibility === "public",
          disabled: e.isSaving,
          onChange: () => e.setNewVisibility("public"),
          children: t("SaveModal.public")
        }
      )
    ] }),
    /* @__PURE__ */ p(ge, { label: t("GroupForm.name"), children: /* @__PURE__ */ p(
      Re,
      {
        value: e.name,
        maxLength: e.maxNameLength,
        disabled: e.isSaving,
        placeholder: t("GroupForm.namePlaceholder"),
        onChange: e.onNameInputChange
      }
    ) }),
    /* @__PURE__ */ p(ge, { label: t("GroupForm.description"), children: /* @__PURE__ */ p(
      Wt,
      {
        value: e.description,
        maxLength: e.maxDescriptionLength,
        minRows: 1,
        maxRows: 5,
        disabled: e.isSaving,
        placeholder: t("GroupForm.descriptionPlaceholder"),
        style: { width: "100%", maxWidth: "100%" },
        onChange: e.onDescriptionChange
      }
    ) })
  ] });
});
var hr = Object.defineProperty, fr = Object.getOwnPropertyDescriptor, x = (r, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? fr(e, t) : e, l = r.length - 1, s; l >= 0; l--)
    (s = r[l]) && (i = (n ? s(e, t, i) : s(i)) || i);
  return n && i && hr(e, t, i), i;
};
class C {
  constructor(e) {
    I(this, "templatesStore");
    I(this, "disposers", []);
    I(this, "maxNameLength", jt);
    I(this, "maxDescriptionLength", Nt);
    I(this, "mode", "new");
    I(this, "name", "");
    I(this, "description", "");
    I(this, "newVisibility", "personal");
    I(this, "existingVisibility", "personal");
    I(this, "selectedGroupId", null);
    this.templatesStore = e, Se(this), this.disposers.push(
      Ae(
        () => this.templatesStore.saveModalOpen,
        (t) => {
          t && this.reset();
        }
      ),
      Ae(
        () => ({
          open: this.templatesStore.saveModalOpen,
          mode: this.mode,
          personalCount: this.templatesStore.personalGroups.length,
          publicCount: this.templatesStore.publicGroups.length,
          existingVisibility: this.existingVisibility
        }),
        () => this.syncExistingVisibility()
      ),
      Ae(
        () => ({
          open: this.templatesStore.saveModalOpen,
          mode: this.mode,
          optionIds: this.existingOptions.map((t) => t.value).join(","),
          selectedGroupId: this.selectedGroupId
        }),
        () => this.syncSelectedGroupId()
      )
    );
  }
  dispose() {
    for (const e of this.disposers)
      e();
    this.disposers.length = 0;
  }
  get isOpen() {
    return this.templatesStore.saveModalOpen;
  }
  get isSaving() {
    return this.templatesStore.isSaving;
  }
  get hasAnyGroups() {
    return this.templatesStore.hasAnyGroups;
  }
  get effectiveMode() {
    return this.hasAnyGroups ? this.mode : "new";
  }
  get isNewMode() {
    return this.effectiveMode === "new";
  }
  get personalDisabled() {
    return this.templatesStore.personalGroups.length === 0;
  }
  get publicDisabled() {
    return this.templatesStore.publicGroups.length === 0;
  }
  get existingOptions() {
    return (this.existingVisibility === "personal" ? this.templatesStore.personalGroups : this.templatesStore.publicGroups).map((t) => ({ value: t.id, label: t.name }));
  }
  get isExistingSelectDisabled() {
    return this.isSaving || this.existingOptions.length === 0;
  }
  get canSubmit() {
    return this.isSaving ? !1 : this.isNewMode ? this.name.trim().length > 0 : W(this.selectedGroupId);
  }
  setMode(e) {
    this.mode = e;
  }
  setNewVisibility(e) {
    this.newVisibility = e;
  }
  setExistingVisibility(e) {
    this.existingVisibility = e;
  }
  onNameInputChange(e) {
    this.name = e.target.value;
  }
  onDescriptionChange(e) {
    this.description = e;
  }
  onSelectedGroupChange(e) {
    this.selectedGroupId = typeof e == "string" ? e : null;
  }
  close() {
    this.templatesStore.closeSaveModal();
  }
  submit() {
    if (this.canSubmit) {
      if (this.isNewMode) {
        this.templatesStore.createGroupFromCurrentSelection(this.name, this.newVisibility, this.description);
        return;
      }
      W(this.selectedGroupId) && this.templatesStore.updateGroupWithCurrentTree(this.selectedGroupId, this.existingVisibility);
    }
  }
  reset() {
    this.mode = "new", this.name = "", this.description = "", this.newVisibility = "personal", this.selectedGroupId = null, this.templatesStore.personalGroups.length > 0 ? this.existingVisibility = "personal" : this.templatesStore.publicGroups.length > 0 ? this.existingVisibility = "public" : this.existingVisibility = "personal";
  }
  syncExistingVisibility() {
    if (!this.templatesStore.saveModalOpen || this.mode !== "existing")
      return;
    const { personalGroups: e, publicGroups: t } = this.templatesStore;
    this.existingVisibility === "personal" && e.length === 0 && t.length > 0 && (this.existingVisibility = "public"), this.existingVisibility === "public" && t.length === 0 && e.length > 0 && (this.existingVisibility = "personal");
  }
  syncSelectedGroupId() {
    var e, t;
    !this.templatesStore.saveModalOpen || this.mode !== "existing" || (!this.selectedGroupId || !this.existingOptions.some((n) => n.value === this.selectedGroupId)) && (this.selectedGroupId = (t = (e = this.existingOptions[0]) == null ? void 0 : e.value) != null ? t : null);
  }
}
x([
  T
], C.prototype, "mode", 2);
x([
  T
], C.prototype, "name", 2);
x([
  T
], C.prototype, "description", 2);
x([
  T
], C.prototype, "newVisibility", 2);
x([
  T
], C.prototype, "existingVisibility", 2);
x([
  T
], C.prototype, "selectedGroupId", 2);
x([
  w
], C.prototype, "isOpen", 1);
x([
  w
], C.prototype, "isSaving", 1);
x([
  w
], C.prototype, "hasAnyGroups", 1);
x([
  w
], C.prototype, "effectiveMode", 1);
x([
  w
], C.prototype, "isNewMode", 1);
x([
  w
], C.prototype, "personalDisabled", 1);
x([
  w
], C.prototype, "publicDisabled", 1);
x([
  w
], C.prototype, "existingOptions", 1);
x([
  w
], C.prototype, "isExistingSelectDisabled", 1);
x([
  w
], C.prototype, "canSubmit", 1);
x([
  y.bound
], C.prototype, "setMode", 1);
x([
  y.bound
], C.prototype, "setNewVisibility", 1);
x([
  y.bound
], C.prototype, "setExistingVisibility", 1);
x([
  y.bound
], C.prototype, "onNameInputChange", 1);
x([
  y.bound
], C.prototype, "onDescriptionChange", 1);
x([
  y.bound
], C.prototype, "onSelectedGroupChange", 1);
x([
  y.bound
], C.prototype, "close", 1);
x([
  y.bound
], C.prototype, "submit", 1);
x([
  y
], C.prototype, "reset", 1);
x([
  y
], C.prototype, "syncExistingVisibility", 1);
x([
  y
], C.prototype, "syncSelectedGroupId", 1);
const mr = L(function({ templatesStore: e }) {
  const { t } = N(), [n] = ie(() => new C(e));
  Me(() => () => n.dispose(), [n]);
  const i = Pe(
    () => [
      { value: "new", label: t("SaveModal.modeNew") },
      { value: "existing", label: t("SaveModal.modeExisting") }
    ],
    [t]
  );
  return /* @__PURE__ */ p(_t, { open: n.isOpen, title: t("SaveModal.title"), onClose: n.close, style: { width: 440 }, children: /* @__PURE__ */ F("div", { className: ee.body, children: [
    n.hasAnyGroups && /* @__PURE__ */ p(
      Tt,
      {
        size: "s",
        value: n.mode,
        items: i,
        onChange: n.setMode,
        className: ee.modeRadios
      }
    ),
    n.isNewMode ? /* @__PURE__ */ p(ur, { store: n }) : /* @__PURE__ */ p(pr, { store: n }),
    /* @__PURE__ */ F("div", { className: ee.actions, children: [
      /* @__PURE__ */ p(M, { variant: "danger", icon: /* @__PURE__ */ p(xt, {}), disabled: n.isSaving, onClick: n.close, children: t("GroupForm.cancel") }),
      /* @__PURE__ */ p(
        M,
        {
          variant: "success",
          icon: /* @__PURE__ */ p(kt, {}),
          loading: n.isSaving,
          disabled: !n.canSubmit,
          onClick: n.submit,
          children: t("GroupForm.save")
        }
      )
    ] })
  ] }) });
}), br = L(function({ store: e, templatesStore: t }) {
  const { t: n } = N(), i = e.hasPendingSelectionChanges, l = !e.hasFiltersHost;
  return /* @__PURE__ */ F(J, { children: [
    /* @__PURE__ */ F("footer", { className: $.footer, children: [
      i && /* @__PURE__ */ F("div", { className: $.selectionActions, children: [
        /* @__PURE__ */ p(
          M,
          {
            variant: "primary",
            size: "m",
            className: D($.selectionButton, "dash-body-medium"),
            onClick: e.applyDraftSelection,
            children: n("Footer.apply")
          }
        ),
        /* @__PURE__ */ p(
          M,
          {
            variant: "secondary",
            size: "m",
            className: D($.selectionButton, "dash-body-medium"),
            onClick: e.resetDraftSelection,
            children: n("Footer.cancel")
          }
        )
      ] }),
      /* @__PURE__ */ F("div", { className: $.selectionActions, children: [
        /* @__PURE__ */ p(
          M,
          {
            variant: "secondary",
            size: "m",
            className: D($.selectionButton, "dash-body-medium"),
            icon: /* @__PURE__ */ p(sn, { className: $.icon }),
            disabled: l,
            onClick: e.importFiltersFromHost,
            children: n("Footer.filter")
          }
        ),
        /* @__PURE__ */ p(
          M,
          {
            variant: "secondary",
            size: "m",
            className: D($.selectionButton, "dash-body-medium"),
            icon: /* @__PURE__ */ p(on, { className: $.icon }),
            disabled: l,
            onClick: e.exportFiltersToHost,
            children: n("Footer.exportFilters")
          }
        )
      ] }),
      /* @__PURE__ */ p(
        M,
        {
          variant: "success",
          size: "m",
          className: D($.saveButton, "dash-body-medium"),
          icon: /* @__PURE__ */ p(an, { className: $.icon }),
          disabled: !t.canCreate || t.isSaving,
          loading: t.isSaving && t.saveModalOpen,
          onClick: t.openSaveModal,
          children: n("Footer.save")
        }
      )
    ] }),
    /* @__PURE__ */ p(mr, { templatesStore: t })
  ] });
}), gr = "panel-header-module__header__4FeMz", yr = "panel-header-module__title__jygu3", Ir = "panel-header-module__closeButton__kGfqu", vr = "panel-header-module__closeIcon__5sTbF", _e = {
  header: gr,
  title: yr,
  closeButton: Ir,
  closeIcon: vr
};
function Sr({ title: r, onClose: e }) {
  const { t } = N();
  return /* @__PURE__ */ F("header", { className: _e.header, children: [
    /* @__PURE__ */ p("span", { className: D("h3", _e.title), children: r }),
    W(e) && /* @__PURE__ */ p(
      M,
      {
        variant: "flat",
        className: _e.closeButton,
        icon: /* @__PURE__ */ p(cn, { className: _e.closeIcon }),
        title: t("Header.close"),
        onClick: e
      }
    )
  ] });
}
const wr = "search-bar-module__root__uqd6I", _r = "search-bar-module__icon__85Cf9", Wr = "search-bar-module__input__GfsSf", je = {
  root: wr,
  icon: _r,
  input: Wr
}, Tr = L(function({ store: e }) {
  const { t } = N();
  return /* @__PURE__ */ p("div", { className: je.root, children: /* @__PURE__ */ p(
    Re,
    {
      allowClear: !0,
      prefix: /* @__PURE__ */ p(dn, { className: je.icon }),
      value: e.searchValue,
      inputClassName: je.input,
      placeholder: t("Panel.searchPlaceholder"),
      onChange: (n) => e.setSearchValue(n.target.value)
    }
  ) });
}), Cr = "tree-node-module__row__0068d", Fr = "tree-node-module__checkbox__T-lzz", xr = "tree-node-module__expandHitArea__tB7cl", kr = "tree-node-module__labelGroup__56zEE", Pr = "tree-node-module__expandButton__697Gr", Dr = "tree-node-module__expandIcon__z6nrC", Er = "tree-node-module__statusIcon__Uf2oI", Gr = "tree-node-module__labelWithTrailing__9OEcT", Ar = "tree-node-module__label__ExS4n", jr = "tree-node-module__children__kV9sb", z = {
  row: Cr,
  checkbox: Fr,
  expandHitArea: xr,
  labelGroup: kr,
  expandButton: Pr,
  expandIcon: Dr,
  statusIcon: Er,
  labelWithTrailing: Gr,
  label: Ar,
  children: jr
};
function H({
  label: r,
  checked: e = !1,
  intermediate: t = !1,
  expanded: n,
  bold: i = !1,
  disabled: l = !1,
  expandable: s = !1,
  icon: o,
  trailing: a,
  children: c,
  onCheckedChange: u,
  onExpandToggle: d
}) {
  const { t: h } = N(), m = s, f = D(i ? "dash-body-bold" : "dash-body-regular", z.label), S = n ? /* @__PURE__ */ p(Ct, { className: z.expandIcon }) : /* @__PURE__ */ p(Ft, { className: z.expandIcon }), _ = /* @__PURE__ */ F(J, { children: [
    m && /* @__PURE__ */ p("span", { className: z.expandButton, children: S }),
    o,
    /* @__PURE__ */ F("span", { className: z.labelWithTrailing, children: [
      /* @__PURE__ */ p("span", { className: f, children: r }),
      a
    ] })
  ] });
  return /* @__PURE__ */ F(J, { children: [
    /* @__PURE__ */ F("div", { className: z.row, children: [
      /* @__PURE__ */ p(
        Zt,
        {
          checked: e,
          intermediate: t,
          size: "s",
          disabled: l,
          className: z.checkbox,
          onChange: u
        }
      ),
      m ? /* @__PURE__ */ p(
        "button",
        {
          type: "button",
          className: z.expandHitArea,
          title: h(n ? "Tree.collapse" : "Tree.expand"),
          onClick: d,
          children: _
        }
      ) : /* @__PURE__ */ p("div", { className: z.labelGroup, children: _ })
    ] }),
    s && n && /* @__PURE__ */ p("div", { className: z.children, children: c })
  ] });
}
function Qe({ status: r }) {
  return /* @__PURE__ */ p(pn, { className: z.statusIcon, style: { color: qt(r) } });
}
function Nr(r) {
  return r ? {
    wellId: r.wellId,
    branch: r.branch,
    designId: r.designId,
    wellboreId: r.wellboreId,
    trajectoryId: r.trajectoryId
  } : null;
}
function Rt(r, e) {
  return !r && !e ? !0 : !r || !e ? !1 : r.wellId === e.wellId && r.branch === e.branch && r.designId === e.designId && r.wellboreId === e.wellboreId && r.trajectoryId === e.trajectoryId;
}
function ve(r, e, t, n, i) {
  return !r || r.wellId !== e || r.branch !== t || r.wellboreId !== n ? !1 : t === "plan" ? r.designId === i : !0;
}
function ze(r, e, t, n, i, l) {
  return W(r == null ? void 0 : r.trajectoryId) ? ve(r, e, t, n, l) && r.trajectoryId === i : !1;
}
function Mt(r, e) {
  return !!r && r.wellId === e && r.branch === "fact";
}
function He(r, e) {
  return !!r && r.wellId === e && r.branch === "plan";
}
function Lt(r, e, t) {
  return He(r, e) && (r == null ? void 0 : r.designId) === t;
}
function Ue(r, e) {
  var t;
  return r.fact === void 0 ? [] : r.fact.length === 0 ? ((t = e == null ? void 0 : e.factWellbores) != null ? t : []).map((n) => ({ wellboreId: n.id, trajectories: [] })) : r.fact.map((n) => structuredClone(n));
}
function Ke(r, e) {
  var t;
  return r.plan === void 0 ? [] : r.plan.length === 0 ? ((t = e == null ? void 0 : e.planDesigns) != null ? t : []).map((n) => ({ designId: n.id, wellbores: [] })) : r.plan.map((n) => structuredClone(n));
}
function Bt(r, e) {
  return r.trajectories.length === 0 ? [...e] : r.trajectories.map((t) => t.trajectoryId);
}
function et(r, e) {
  return r.filter((t) => t.wellboreId !== e);
}
function tt(r, e, t, n) {
  const i = r.find((a) => a.wellboreId === e);
  if (!i)
    return r;
  const l = new Set(Bt(i, n));
  l.delete(t);
  const s = r.filter((a) => a.wellboreId !== e);
  if (l.size === 0)
    return s;
  const o = n.length > 0 && l.size === n.length ? [] : Array.from(l).map((a) => ({ trajectoryId: a }));
  return s.push({ wellboreId: e, trajectories: o }), s;
}
function nt(r, e, t, n) {
  const i = r.find((a) => a.wellboreId === e), l = new Set(i ? Bt(i, n) : []);
  l.add(t);
  const s = r.filter((a) => a.wellboreId !== e), o = n.length > 0 && l.size === n.length ? [] : Array.from(l).map((a) => ({ trajectoryId: a }));
  return s.push({ wellboreId: e, trajectories: o }), s;
}
function Ot(r, e) {
  var t, n;
  return (n = (t = r == null ? void 0 : r.factWellbores.find((i) => i.id === e)) == null ? void 0 : t.trajectories.map((i) => i.id)) != null ? n : [];
}
function $t(r, e, t) {
  var n, i, l;
  return (l = (i = (n = r == null ? void 0 : r.planDesigns.find((s) => s.id === e)) == null ? void 0 : n.wellbores.find((s) => s.id === t)) == null ? void 0 : i.trajectories.map((s) => s.id)) != null ? l : [];
}
function Rr(r, e, t) {
  var u;
  const n = structuredClone(r);
  if (e.branch === "fact") {
    if (n.fact === void 0)
      return n;
    const d = Ue(n, t), h = et(d, e.wellboreId);
    if (h.length === 0)
      delete n.fact;
    else if (t && h.length === t.factWellbores.length) {
      const m = h.every((f) => f.trajectories.length === 0);
      n.fact = m ? [] : h;
    } else
      n.fact = h;
    return n;
  }
  if (n.plan === void 0 || !W(e.designId))
    return n;
  const i = Ke(n, t), l = i.find((d) => d.designId === e.designId), s = t == null ? void 0 : t.planDesigns.find((d) => d.id === e.designId);
  if (!l)
    return n;
  const o = l.wellbores.length === 0 ? (u = s == null ? void 0 : s.wellbores.map((d) => ({
    wellboreId: d.id,
    trajectories: []
  }))) != null ? u : [] : l.wellbores, a = et(o, e.wellboreId), c = i.filter((d) => d.designId !== e.designId);
  if (a.length === 0)
    return c.length === 0 ? delete n.plan : n.plan = c, n;
  if (c.push({ designId: e.designId, wellbores: a }), t && c.length === t.planDesigns.length) {
    const d = c.every((h) => h.wellbores.length === 0);
    n.plan = d ? [] : c;
  } else
    n.plan = c;
  return n;
}
function rt(r, e) {
  return r.find((n) => n.wellboreId === e) ? r : [...r, { wellboreId: e, trajectories: [] }];
}
function Vt(r, e, t) {
  var u;
  const n = structuredClone(r);
  if (e.branch === "fact") {
    const d = Ue(n, t), h = W(e.trajectoryId) ? nt(
      d,
      e.wellboreId,
      e.trajectoryId,
      Ot(t, e.wellboreId)
    ) : rt(d, e.wellboreId);
    if (t && h.length === t.factWellbores.length) {
      const m = h.every((f) => f.trajectories.length === 0);
      n.fact = m ? [] : h;
    } else
      n.fact = h;
    return n;
  }
  if (!W(e.designId))
    return n;
  const i = Ke(n, t), l = t == null ? void 0 : t.planDesigns.find((d) => d.id === e.designId), s = i.find((d) => d.designId === e.designId), o = s ? s.wellbores.length === 0 ? (u = l == null ? void 0 : l.wellbores.map((d) => ({
    wellboreId: d.id,
    trajectories: []
  }))) != null ? u : [] : s.wellbores.map((d) => structuredClone(d)) : [], a = W(e.trajectoryId) ? nt(
    o,
    e.wellboreId,
    e.trajectoryId,
    $t(t, e.designId, e.wellboreId)
  ) : rt(o, e.wellboreId), c = i.filter((d) => d.designId !== e.designId);
  if (c.push({ designId: e.designId, wellbores: a }), t && c.length === t.planDesigns.length) {
    const d = c.every((h) => h.wellbores.length === 0);
    n.plan = d ? [] : c;
  } else
    n.plan = c;
  return n;
}
function Ye(r, e, t, n) {
  const l = j(r).wells.map((o) => structuredClone(o)), s = e && t && e.wellId === t.wellId && e.branch === t.branch && e.designId === t.designId && e.wellboreId === t.wellboreId;
  if (e && !Rt(e, t)) {
    const o = l.findIndex((a) => a.wellId === e.wellId);
    o >= 0 && (s ? l[o] = Mr(l[o], e, n(e.wellId)) : l[o] = Rr(l[o], e, n(e.wellId)));
  }
  if (t) {
    let o = l.findIndex((a) => a.wellId === t.wellId);
    o < 0 && (l.push({ wellId: t.wellId }), o = l.length - 1), l[o] = Vt(l[o], t, n(t.wellId));
  }
  return {
    wells: l.filter((o) => o.fact !== void 0 || o.plan !== void 0)
  };
}
function Mr(r, e, t) {
  var h;
  if (!W(e.trajectoryId))
    return r;
  const n = structuredClone(r), i = e.trajectoryId;
  if (e.branch === "fact") {
    if (n.fact === void 0)
      return n;
    const m = Ue(n, t), f = Ot(t, e.wellboreId), S = tt(m, e.wellboreId, i, f);
    if (S.length === 0)
      delete n.fact;
    else if (t && S.length === t.factWellbores.length) {
      const _ = S.every((v) => v.trajectories.length === 0);
      n.fact = _ ? [] : S;
    } else
      n.fact = S;
    return n;
  }
  if (n.plan === void 0 || !W(e.designId))
    return n;
  const l = Ke(n, t), s = l.find((m) => m.designId === e.designId), o = t == null ? void 0 : t.planDesigns.find((m) => m.id === e.designId);
  if (!s)
    return n;
  const a = s.wellbores.length === 0 ? (h = o == null ? void 0 : o.wellbores.map((m) => ({
    wellboreId: m.id,
    trajectories: []
  }))) != null ? h : [] : s.wellbores, c = $t(t, e.designId, e.wellboreId), u = tt(a, e.wellboreId, i, c), d = l.filter((m) => m.designId !== e.designId);
  if (u.length === 0)
    return d.length === 0 ? delete n.plan : n.plan = d, n;
  if (d.push({ designId: e.designId, wellbores: u }), t && d.length === t.planDesigns.length) {
    const m = d.every((f) => f.wellbores.length === 0);
    n.plan = m ? [] : d;
  } else
    n.plan = d;
  return n;
}
function Lr(r, e, t) {
  return e ? Ye(r, null, e, t) : j(r);
}
function it(r, e, t) {
  return !e || e.wellId !== r.wellId ? r : Vt(r, e, t);
}
const Br = "active-status-icon-module__wrap__QpGQJ", Or = "active-status-icon-module__icon__KxppE", lt = {
  wrap: Br,
  icon: Or
};
function $r({ className: r }) {
  const { t: e } = N(), t = e("Filters.statusActive");
  return /* @__PURE__ */ p("span", { className: D(lt.wrap, r), title: t, "aria-label": t, children: /* @__PURE__ */ p(un, { className: lt.icon }) });
}
const Vr = "redrilling-badge-module__badge__mnr97", zr = {
  badge: Vr
};
function Hr({ redrillingIndex: r, backgroundColor: e, className: t }) {
  const { t: n } = N();
  return /* @__PURE__ */ F(
    "span",
    {
      className: D("dash-body-regular", zr.badge, t),
      style: e ? { backgroundColor: e } : void 0,
      children: [
        n("Panel.redrill"),
        " ",
        r
      ]
    }
  );
}
const Ur = [
  "rgba(255, 105, 180, 0.3)",
  "rgba(111, 207, 151, 0.3)",
  "rgba(125, 168, 255, 0.3)",
  "rgba(242, 153, 74, 0.3)",
  "rgba(155, 89, 182, 0.3)",
  "rgba(38, 198, 218, 0.3)",
  "rgba(255, 214, 102, 0.3)",
  "rgba(235, 87, 87, 0.3)",
  "rgba(178, 136, 255, 0.3)",
  "rgba(168, 196, 88, 0.3)"
];
function Kr(r) {
  var n;
  const e = Ur;
  if (e.length === 0)
    return "transparent";
  const t = Math.max(0, r) % e.length;
  return (n = e[t]) != null ? n : e[0];
}
function Yr(r) {
  const e = /* @__PURE__ */ new Map();
  for (const i of r) {
    if (!W(i.redrillingIndex) || i.typeInstanceId == null)
      continue;
    const l = e.get(i.typeInstanceId);
    (!l || i.typeIndex < l.typeIndex) && e.set(i.typeInstanceId, { typeIndex: i.typeIndex });
  }
  const t = [...e.entries()].sort((i, l) => {
    const s = i[1].typeIndex - l[1].typeIndex;
    return s !== 0 ? s : i[0] - l[0];
  }).map(([i]) => i), n = /* @__PURE__ */ new Map();
  return t.forEach((i, l) => {
    n.set(i, Kr(l));
  }), n;
}
function xe(r) {
  const { isActive: e, redrillBadge: t } = r;
  if (!(!t && !e))
    return /* @__PURE__ */ F(J, { children: [
      t,
      e ? /* @__PURE__ */ p($r, {}) : null
    ] });
}
const st = L(function({
  store: e,
  wellId: t,
  wellbores: n,
  disabled: i,
  forced: l,
  redrillingColorsByTypeInstanceId: s
}) {
  return n.map(({ wellbore: o, checkState: a, trajectories: c }) => {
    const u = ve(l, t, "fact", o.id), d = i || u, h = o.typeInstanceId != null ? s.get(o.typeInstanceId) : void 0, m = W(o.redrillingIndex) ? /* @__PURE__ */ p(Hr, { redrillingIndex: o.redrillingIndex, backgroundColor: h }) : void 0;
    return /* @__PURE__ */ p(
      H,
      {
        label: o.name,
        checked: B(a) || u,
        intermediate: q(a) && !u,
        disabled: d,
        expandable: c.length > 0,
        expanded: e.isWellboreExpanded(t, "fact", o.id),
        trailing: xe({ isActive: o.isActive, redrillBadge: m }),
        onCheckedChange: d ? void 0 : (f) => e.setFactWellboreChecked(t, o.id, f),
        onExpandToggle: () => e.toggleWellboreExpanded(t, "fact", o.id),
        children: c.map(({ trajectory: f, checkState: S }) => {
          const _ = ze(l, t, "fact", o.id, f.id), v = i || _;
          return /* @__PURE__ */ p(
            H,
            {
              label: f.name,
              checked: B(S) || _,
              disabled: v,
              trailing: xe({ isActive: f.isActive }),
              onCheckedChange: v ? void 0 : (R) => e.setFactTrajectoryChecked(t, o.id, f.id, R)
            },
            `fact-traj-${f.id}`
          );
        })
      },
      `fact-wb-${o.id}`
    );
  });
}), ot = L(function({
  store: e,
  wellId: t,
  designs: n,
  disabled: i,
  forced: l
}) {
  return n.map(({ design: s, checkState: o, wellbores: a }) => {
    const c = Lt(l, t, s.id), u = i || c;
    return /* @__PURE__ */ p(
      H,
      {
        label: s.name,
        checked: B(o) || c,
        intermediate: q(o) && !c,
        disabled: u,
        expandable: a.length > 0,
        expanded: e.isDesignExpanded(t, s.id),
        onCheckedChange: u ? void 0 : (d) => e.setDesignChecked(t, s.id, d),
        onExpandToggle: () => e.toggleDesignExpanded(t, s.id),
        children: a.map(({ wellbore: d, checkState: h, trajectories: m }) => {
          const f = ve(l, t, "plan", d.id, s.id), S = i || f;
          return /* @__PURE__ */ p(
            H,
            {
              label: d.name,
              checked: B(h) || f,
              intermediate: q(h) && !f,
              disabled: S,
              expandable: m.length > 0,
              expanded: e.isWellboreExpanded(t, "plan", d.id, s.id),
              trailing: xe({ isActive: d.isActive }),
              onCheckedChange: S ? void 0 : (_) => e.setPlanWellboreChecked(t, s.id, d.id, _),
              onExpandToggle: () => e.toggleWellboreExpanded(t, "plan", d.id, s.id),
              children: m.map(({ trajectory: _, checkState: v }) => {
                const R = ze(
                  l,
                  t,
                  "plan",
                  d.id,
                  _.id,
                  s.id
                ), O = i || R;
                return /* @__PURE__ */ p(
                  H,
                  {
                    label: _.name,
                    checked: B(v) || R,
                    disabled: O,
                    trailing: xe({ isActive: _.isActive }),
                    onCheckedChange: O ? void 0 : (ne) => e.setPlanTrajectoryChecked(t, s.id, d.id, _.id, ne)
                  },
                  `plan-traj-${s.id}-${_.id}`
                );
              })
            },
            `plan-wb-${s.id}-${d.id}`
          );
        })
      },
      `design-${s.id}`
    );
  });
}), at = L(function({
  store: e,
  wellId: t,
  planCheckState: n,
  factCheckState: i,
  disabled: l = !1
}) {
  var v, R;
  const { t: s } = N(), { fact: o, plan: a, showFactGroup: c, showPlanGroup: u } = e.getVisibleWellBranch(t), d = e.forcedPrimarySelection, h = Yr(
    (R = (v = e.getWellChildren(t)) == null ? void 0 : v.factWellbores) != null ? R : []
  ), m = Mt(d, t), f = He(d, t), S = l || m, _ = l || f;
  return /* @__PURE__ */ F(J, { children: [
    o !== null && (c ? /* @__PURE__ */ p(
      H,
      {
        label: s("Panel.fact"),
        checked: B(i) || m,
        intermediate: q(i) && !m,
        disabled: S,
        expandable: o.length > 0,
        expanded: e.isFactExpanded(t),
        onCheckedChange: S ? void 0 : (O) => e.setFactChecked(t, O),
        onExpandToggle: () => e.toggleFactExpanded(t),
        children: /* @__PURE__ */ p(
          st,
          {
            store: e,
            wellId: t,
            wellbores: o,
            disabled: l,
            forced: d,
            redrillingColorsByTypeInstanceId: h
          }
        )
      }
    ) : /* @__PURE__ */ p(
      st,
      {
        store: e,
        wellId: t,
        wellbores: o,
        disabled: l,
        forced: d,
        redrillingColorsByTypeInstanceId: h
      }
    )),
    a !== null && (u ? /* @__PURE__ */ p(
      H,
      {
        label: s("Panel.plan"),
        checked: B(n) || f,
        intermediate: q(n) && !f,
        disabled: _,
        expandable: a.length > 0,
        expanded: e.isPlanExpanded(t),
        onCheckedChange: _ ? void 0 : (O) => e.setPlanChecked(t, O),
        onExpandToggle: () => e.togglePlanExpanded(t),
        children: /* @__PURE__ */ p(ot, { store: e, wellId: t, designs: a, disabled: l, forced: d })
      }
    ) : /* @__PURE__ */ p(ot, { store: e, wellId: t, designs: a, disabled: l, forced: d }))
  ] });
}), Xr = { title: "Offset wells", tabWells: "Wells", tabGroups: "Groups", primaryWell: "Active well", plan: "Plan", fact: "Fact", loading: "Loading…", all: "Offset wells", emptyNameFallback: "—", searchPlaceholder: "Search wells", redrill: "Redrill" }, Zr = { title: "Filters", statusActive: "Active", statusCompleted: "Completed" }, Jr = { public: "Public", personal: "Personal", empty: "No groups yet", loading: "Loading…" }, qr = { menu: "Actions", apply: "Apply", rename: "Edit", copyToPublic: "Copy to public", copyToPersonal: "Copy to personal", delete: "Delete", addFavorite: "Add to favorites", removeFavorite: "Remove from favorites" }, Qr = { name: "Name", namePlaceholder: "Enter a name", description: "Description", descriptionPlaceholder: "Enter a description", cancel: "Cancel", save: "Save" }, ei = { title: "Save", modeNew: "New group", modeExisting: "Existing group", personal: "Personal", public: "Public", group: "Group", groupPlaceholder: "Select a group" }, ti = { title: "Edit group" }, ni = { apply: "Apply", cancel: "Cancel", filter: "Filter", exportFilters: "Export filters", save: "Save" }, ri = { collapse: "Collapse", expand: "Expand" }, ii = { close: "Close" }, li = {
  Panel: Xr,
  Filters: Zr,
  Groups: Jr,
  GroupActions: qr,
  GroupForm: Qr,
  SaveModal: ei,
  RenameModal: ti,
  Footer: ni,
  Tree: ri,
  Header: ii
}, si = { title: "Pozos de referencia", tabWells: "Pozos", tabGroups: "Grupos", primaryWell: "Pozo activo", plan: "Plan", fact: "Hecho", loading: "Cargando…", all: "Pozos de referencia", emptyNameFallback: "—", searchPlaceholder: "Buscar pozos", redrill: "Redrill" }, oi = { title: "Filtros", statusActive: "Activos", statusCompleted: "Finalizados" }, ai = { public: "Públicos", personal: "Personales", empty: "Aún no hay grupos", loading: "Cargando…" }, ci = { menu: "Acciones", apply: "Aplicar", rename: "Editar", copyToPublic: "Copiar a públicos", copyToPersonal: "Copiar a personales", delete: "Eliminar", addFavorite: "Añadir a favoritos", removeFavorite: "Quitar de favoritos" }, di = { name: "Nombre", namePlaceholder: "Introduzca un nombre", description: "Descripción", descriptionPlaceholder: "Introduzca una descripción", cancel: "Cancelar", save: "Guardar" }, pi = { title: "Guardar", modeNew: "Grupo nuevo", modeExisting: "Grupo existente", personal: "Personales", public: "Públicos", group: "Grupo", groupPlaceholder: "Seleccione un grupo" }, ui = { title: "Editar grupo" }, hi = { apply: "Aplicar", cancel: "Cancelar", filter: "Filtrar", exportFilters: "Exportar filtros", save: "Guardar" }, fi = { collapse: "Contraer", expand: "Expandir" }, mi = { close: "Cerrar" }, bi = {
  Panel: si,
  Filters: oi,
  Groups: ai,
  GroupActions: ci,
  GroupForm: di,
  SaveModal: pi,
  RenameModal: ui,
  Footer: hi,
  Tree: fi,
  Header: mi
}, gi = { title: "Опорные скважины", tabWells: "Скважины", tabGroups: "Группы", primaryWell: "Активная скважина", plan: "План", fact: "Факт", loading: "Загрузка…", all: "Опорные скважины", emptyNameFallback: "—", searchPlaceholder: "Поиск скважин", redrill: "Перебур" }, yi = { title: "Фильтры", statusActive: "Активные", statusCompleted: "Законченные" }, Ii = { public: "Общие", personal: "Личные", empty: "Групп пока нет", loading: "Загрузка…" }, vi = { menu: "Действия", apply: "Применить", rename: "Редактировать", copyToPublic: "Копировать в общие", copyToPersonal: "Копировать в личные", delete: "Удалить", addFavorite: "В избранное", removeFavorite: "Убрать из избранного" }, Si = { name: "Название", namePlaceholder: "Введите название", description: "Описание", descriptionPlaceholder: "Введите описание", cancel: "Отмена", save: "Сохранить" }, wi = { title: "Сохранить", modeNew: "Новая группа", modeExisting: "Существующая группа", personal: "Персональные", public: "Публичные", group: "Группа", groupPlaceholder: "Выберите группу" }, _i = { title: "Редактировать группу" }, Wi = { apply: "Применить", cancel: "Отменить", filter: "Отфильтровать", exportFilters: "Экспорт фильтров", save: "Сохранить" }, Ti = { collapse: "Свернуть", expand: "Развернуть" }, Ci = { close: "Закрыть" }, Fi = {
  Panel: gi,
  Filters: yi,
  Groups: Ii,
  GroupActions: vi,
  GroupForm: Si,
  SaveModal: wi,
  RenameModal: _i,
  Footer: Wi,
  Tree: Ti,
  Header: Ci
}, We = "referenceWells";
function xi(r) {
  const e = hn.createInstance();
  if (e.use(en).init({
    resources: {
      en: { [We]: li },
      ru: { [We]: Fi },
      es: { [We]: bi }
    },
    lng: "en",
    fallbackLng: "en",
    defaultNS: We,
    interpolation: {
      escapeValue: !1
    }
  }), r) {
    const t = e.t.bind(e);
    e.t = ((n, i) => {
      const l = Array.isArray(n) ? String(n[0]) : String(n);
      return e.exists(l) ? t(n, i) : r.exists(l) ? r.t(l, i) : t(n, i);
    });
  }
  return e;
}
function ki({ language: r, parentI18n: e, children: t }) {
  const n = Pe(() => xi(e), [e]);
  return Me(() => {
    n.changeLanguage(r);
  }, [n, r]), /* @__PURE__ */ p(tn, { i18n: n, children: t });
}
const Pi = "reference-wells-panel-module__panel__dv9xf", Di = "reference-wells-panel-module__panelEmbedded__qPp8D", Ei = "reference-wells-panel-module__tabsBar__OWuZO", Gi = "reference-wells-panel-module__tabs__Wbb9b", Ai = "reference-wells-panel-module__sectionLabel__vZnmf", ji = "reference-wells-panel-module__previewTree__86tbs", Ni = "reference-wells-panel-module__treeArea__ZtlpD", Ri = "reference-wells-panel-module__scrollbar__g6FrG", Mi = "reference-wells-panel-module__treeList__F5BGv", Li = "reference-wells-panel-module__loadingPlaceholder__E5FUI", V = {
  panel: Pi,
  panelEmbedded: Di,
  tabsBar: Ei,
  tabs: Gi,
  sectionLabel: Ai,
  previewTree: ji,
  treeArea: Ni,
  scrollbar: Ri,
  treeList: Mi,
  loadingPlaceholder: Li
}, Bi = L(function({
  store: e,
  templatesStore: t,
  primaryWellName: n = null,
  showHeader: i = !0,
  onClose: l
}) {
  const { t: s } = N(), [o, a] = ie("wells"), c = e.primaryWellId, u = e.primaryWell, d = e.wellTreeRows, h = e.isLoading, m = (n == null ? void 0 : n.trim()) || (u == null ? void 0 : u.name) || (W(c) ? String(c) : s("Panel.emptyNameFallback")), f = Pe(
    () => [
      { value: "wells", label: s("Panel.tabWells") },
      { value: "groups", label: s("Panel.tabGroups") }
    ],
    [s]
  ), S = W(c) ? e.getWellChildren(c) : void 0, _ = W(c) ? e.selectedTree.wells.find((E) => E.wellId === c) : void 0, v = e.lockPrimaryWellSubtree, R = W(c) ? $e(e.selectedTree, c, S, e.visibility) : "unchecked", O = Oe(_, S, e.visibility), ne = Be(_, S, e.visibility);
  return /* @__PURE__ */ F("aside", { className: D(V.panel, !i && V.panelEmbedded), children: [
    i && /* @__PURE__ */ p(Sr, { title: s("Panel.title"), onClose: l }),
    /* @__PURE__ */ p("div", { className: V.tabsBar, children: /* @__PURE__ */ p(Tt, { size: "s", value: o, items: f, onChange: a, className: V.tabs }) }),
    o === "wells" ? /* @__PURE__ */ F(J, { children: [
      /* @__PURE__ */ p("div", { className: D("dash-body-bold", V.sectionLabel), children: s("Panel.primaryWell") }),
      /* @__PURE__ */ p("div", { className: V.previewTree, children: W(c) ? /* @__PURE__ */ p(
        H,
        {
          label: m,
          checked: B(R),
          intermediate: q(R),
          disabled: !0,
          expandable: !v && e.wellHasVisibleChildren(c),
          expanded: !v && e.primaryExpanded,
          onExpandToggle: v ? void 0 : e.togglePrimaryExpanded,
          icon: u ? /* @__PURE__ */ p(Qe, { status: u.status }) : void 0,
          children: !v && /* @__PURE__ */ p(
            at,
            {
              store: e,
              wellId: c,
              planCheckState: O,
              factCheckState: ne
            }
          )
        }
      ) : /* @__PURE__ */ p("span", { className: D("dash-body-regular", V.loadingPlaceholder), children: s("Panel.emptyNameFallback") }) }),
      /* @__PURE__ */ p(Nn, { store: e }),
      /* @__PURE__ */ p(Tr, { store: e }),
      /* @__PURE__ */ p("div", { className: V.treeArea, children: /* @__PURE__ */ p(Jt, { className: V.scrollbar, children: /* @__PURE__ */ p("div", { className: V.treeList, children: h && d.length === 0 ? /* @__PURE__ */ p("span", { className: D("dash-body-regular", V.loadingPlaceholder), children: s("Panel.loading") }) : /* @__PURE__ */ p(
        H,
        {
          label: s("Panel.all"),
          bold: !0,
          checked: e.allChecked,
          intermediate: e.allIntermediate,
          expanded: e.rootExpanded,
          expandable: d.length > 0,
          onCheckedChange: e.setAllChecked,
          onExpandToggle: e.toggleRootExpanded,
          children: d.map((E) => /* @__PURE__ */ p(
            H,
            {
              label: E.well.name,
              checked: B(E.checkState),
              intermediate: q(E.checkState),
              expandable: E.hasVisibleChildren,
              expanded: E.expanded,
              onCheckedChange: (ae) => e.setWellChecked(E.well.id, ae),
              onExpandToggle: () => e.toggleWellExpanded(E.well.id),
              icon: /* @__PURE__ */ p(Qe, { status: E.well.status }),
              children: /* @__PURE__ */ p(
                at,
                {
                  store: e,
                  wellId: E.well.id,
                  planCheckState: E.planCheckState,
                  factCheckState: E.factCheckState
                }
              )
            },
            E.well.id
          ))
        }
      ) }) }) }),
      /* @__PURE__ */ p(br, { store: e, templatesStore: t })
    ] }) : /* @__PURE__ */ p(lr, { templatesStore: t })
  ] });
});
function vl({ language: r, parentI18n: e, ...t }) {
  return /* @__PURE__ */ p(ki, { language: r, parentI18n: e, children: /* @__PURE__ */ p(Bi, { ...t }) });
}
function Oi(r) {
  const e = r.find((n) => n.isActive);
  if (e)
    return e;
  const t = r.find(
    (n) => n.typeSlug.toLowerCase() === "main" && n.redrillingIndex === null
  );
  return t || (r.length > 0 ? r[0] : null);
}
var $i = Object.defineProperty, Vi = Object.getOwnPropertyDescriptor, G = (r, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? Vi(e, t) : e, l = r.length - 1, s; l >= 0; l--)
    (s = r[l]) && (i = (n ? s(e, t, i) : s(i)) || i);
  return n && i && $i(e, t, i), i;
};
function zi(r) {
  return {
    ...te,
    ...r
  };
}
class A {
  constructor(e) {
    I(this, "wellsSource");
    I(this, "onSelectionChange");
    I(this, "disposed", !1);
    I(this, "_primaryWellId");
    I(this, "_selectedTree");
    I(this, "_visibility");
    I(this, "_wellChildrenByWellId", /* @__PURE__ */ new Map());
    I(this, "_forcedPrimarySelection", null);
    I(this, "_lockPrimaryWellSubtree");
    var t, n, i;
    this.wellsSource = e.wellsSource, this.onSelectionChange = (t = e.onSelectionChange) != null ? t : null, this._primaryWellId = (n = e.primaryWellId) != null ? n : null, this._visibility = zi(e.visibility), this._lockPrimaryWellSubtree = (i = e.lockPrimaryWellSubtree) != null ? i : !1, this._selectedTree = Ie(), Se(this), e.initialSelectedTree && this.setSelectedTree(e.initialSelectedTree);
  }
  get wellsSourceRef() {
    return this.wellsSource;
  }
  get primaryWellId() {
    return this._primaryWellId;
  }
  get selectedTree() {
    return this._selectedTree;
  }
  /**
   * Explicit selected ids only (no whole-branch `[]` shorthand).
   * Use for widget consumers; omit unselected fact/plan branches.
   */
  getSelectedTreeForConsumers() {
    return Tn(
      this._selectedTree,
      (e) => this._wellChildrenByWellId.get(e),
      this._visibility
    );
  }
  get visibility() {
    return this._visibility;
  }
  get lockPrimaryWellSubtree() {
    return this._lockPrimaryWellSubtree;
  }
  get forcedPrimarySelection() {
    return this._forcedPrimarySelection;
  }
  get wellChildrenByWellId() {
    return this._wellChildrenByWellId;
  }
  getWellChildren(e) {
    return this._wellChildrenByWellId.get(e);
  }
  setOnSelectionChange(e) {
    this.onSelectionChange = e;
  }
  setPrimaryWellId(e) {
    this._primaryWellId = e;
  }
  setAllWellChildren(e) {
    this._wellChildrenByWellId = new Map(e), this.setSelectedTree(this._selectedTree);
  }
  ensureDefaultPrimaryWellboreSelection() {
    if (this.disposed || !this._visibility.showFact)
      return !1;
    const e = this._primaryWellId;
    if (!W(e))
      return !1;
    const t = this._forcedPrimarySelection;
    if (t && t.wellId === e)
      return !1;
    const n = this._selectedTree.wells.find((a) => a.wellId === e);
    if ((n == null ? void 0 : n.fact) !== void 0)
      return !1;
    const i = this._wellChildrenByWellId.get(e), l = i ? Oi(i.factWellbores) : null;
    if (!l)
      return !1;
    const s = j(this._selectedTree).wells, o = s.find((a) => a.wellId === e);
    return o ? o.fact = [{ wellboreId: l.id, trajectories: [] }] : s.push({
      wellId: e,
      fact: [{ wellboreId: l.id, trajectories: [] }]
    }), this.setSelectedTree({ wells: s }), !0;
  }
  setForcedPrimarySelection(e) {
    this.assertAlive();
    const t = this._forcedPrimarySelection;
    if (Rt(t, e))
      return;
    const n = Ye(
      this._selectedTree,
      t,
      e,
      (i) => this._wellChildrenByWellId.get(i)
    );
    this._forcedPrimarySelection = Nr(e), this.setSelectedTree(n);
  }
  setSelectedTree(e) {
    this.assertAlive();
    const t = (l) => this._wellChildrenByWellId.get(l), n = Lr(e, this._forcedPrimarySelection, t), i = At(n, t, this._visibility);
    this._selectedTree = j(i), this.notifySelectionChange();
  }
  dispose() {
    this.disposed || (this.disposed = !0, this.onSelectionChange = null, this._selectedTree = Ie(), this._primaryWellId = null, this._wellChildrenByWellId = /* @__PURE__ */ new Map(), this._forcedPrimarySelection = null);
  }
  notifySelectionChange() {
    var e;
    (e = this.onSelectionChange) == null || e.call(this, this.getSelectedTreeForConsumers());
  }
  assertAlive() {
    if (this.disposed)
      throw new Error("ReferenceWellsService is disposed");
  }
}
G([
  T.ref
], A.prototype, "_primaryWellId", 2);
G([
  T.ref
], A.prototype, "_selectedTree", 2);
G([
  T.ref
], A.prototype, "_visibility", 2);
G([
  T.ref
], A.prototype, "_wellChildrenByWellId", 2);
G([
  T.ref
], A.prototype, "_forcedPrimarySelection", 2);
G([
  w
], A.prototype, "primaryWellId", 1);
G([
  w
], A.prototype, "selectedTree", 1);
G([
  w
], A.prototype, "visibility", 1);
G([
  w
], A.prototype, "forcedPrimarySelection", 1);
G([
  w
], A.prototype, "wellChildrenByWellId", 1);
G([
  y.bound
], A.prototype, "setOnSelectionChange", 1);
G([
  y.bound
], A.prototype, "setPrimaryWellId", 1);
G([
  y.bound
], A.prototype, "setAllWellChildren", 1);
G([
  y.bound
], A.prototype, "ensureDefaultPrimaryWellboreSelection", 1);
G([
  y.bound
], A.prototype, "setForcedPrimarySelection", 1);
G([
  y.bound
], A.prototype, "setSelectedTree", 1);
G([
  y.bound
], A.prototype, "dispose", 1);
function Z(r, e) {
  return e.length === 0 ? !0 : r == null ? !1 : e.includes(r);
}
function ct(r, e) {
  var t, n, i, l, s, o, a, c, u, d;
  if (!e || he(e))
    return !0;
  if (e.status.length > 0) {
    const h = r.status.toLowerCase();
    if (!e.status.some((f) => h.includes(f.toString().toLowerCase())))
      return !1;
  }
  return !(!Z((i = (t = r.block) == null ? void 0 : t.organizationId) != null ? i : (n = r.organization) == null ? void 0 : n.id, e.organizationId) || !Z((l = r.block) == null ? void 0 : l.id, e.blockId) || !Z((s = r.field) == null ? void 0 : s.id, e.fieldId) || !Z((a = r.padId) != null ? a : (o = r.pad) == null ? void 0 : o.id, e.padId) || !Z(r.id, e.wellId) || !Z((c = r.rigModel) == null ? void 0 : c.id, e.rigModelId) || !Z((d = r.brigadeId) != null ? d : (u = r.brigade) == null ? void 0 : u.id, e.brigadeId));
}
function Ce(r, e) {
  return !e || e.wellboreTypeInstanceId.length === 0 ? !0 : Z(r.typeInstanceId, e.wellboreTypeInstanceId);
}
function dt(r, e) {
  return e ? {
    wellbore: r,
    trajectories: [...r.trajectories]
  } : {
    wellbore: r,
    trajectories: []
  };
}
function pt(r, e, t) {
  return r.filter((n) => t != null && n.id === t ? !0 : Ce(n, e != null ? e : null));
}
function Hi(r, e, t = null, n = null) {
  const i = (() => {
    var c;
    return e.showFact ? e.showWellbores ? pt((c = r == null ? void 0 : r.factWellbores) != null ? c : [], t, n).map(
      (u) => dt(u, e.showTrajectories)
    ) : [] : null;
  })(), l = (() => {
    var c;
    return e.showPlan ? ((c = r == null ? void 0 : r.planDesigns) != null ? c : []).map((u) => ({
      design: u,
      wellbores: e.showWellbores ? pt(u.wellbores, t, n).map(
        (d) => dt(d, e.showTrajectories)
      ) : []
    })) : null;
  })(), s = e.showFact && e.showPlan;
  return { fact: i, plan: l, showFactGroup: s && i !== null, showPlanGroup: s && l !== null };
}
function ut(r) {
  return !!(r.showFactGroup || r.showPlanGroup || r.fact !== null && r.fact.length > 0 || r.plan !== null && r.plan.length > 0);
}
const se = 1, ht = 0.5, ft = 0.2, ke = 0.1, Ui = 0.03, Ki = 0.02, Yi = 0.01;
function mt(r) {
  return r === "ACTIVE_GREEN" || r === "ACTIVE_YELLOW";
}
function bt(r) {
  return r < 0 ? -1 : r > 0 ? 1 : 0;
}
function Xe(r, e) {
  return r.localeCompare(e, void 0, { sensitivity: "base" }) * Yi;
}
function Xi(r, e) {
  const t = le(r.checkState) ? se : 0, n = le(e.checkState) ? se : 0, i = mt(r.status) ? ht : 0, l = mt(e.status) ? ht : 0;
  return n - t + (l - i) + Xe(r.name, e.name);
}
function gt(r, e) {
  const t = le(r.checkState) ? se : 0, n = le(e.checkState) ? se : 0, i = r.isActive ? ke : 0, l = e.isActive ? ke : 0;
  return n - t + (l - i) + Xe(r.name, e.name);
}
function yt(r, e) {
  var u, d;
  const t = le(r.checkState) ? se : 0, n = le(e.checkState) ? se : 0, i = r.typeSlug.toLowerCase() === "main" ? ft : 0, l = e.typeSlug.toLowerCase() === "main" ? ft : 0, s = r.isActive ? ke : 0, o = e.isActive ? ke : 0, a = bt(r.typeIndex - e.typeIndex) * Ui, c = bt(((u = r.redrillingIndex) != null ? u : 0) - ((d = e.redrillingIndex) != null ? d : 0)) * Ki;
  return n - t + (l - i) + (o - s) + a + c + Xe(r.name, e.name);
}
var Zi = Object.defineProperty, Ji = Object.getOwnPropertyDescriptor, b = (r, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? Ji(e, t) : e, l = r.length - 1, s; l >= 0; l--)
    (s = r[l]) && (i = (n ? s(e, t, i) : s(i)) || i);
  return n && i && Zi(e, t, i), i;
};
function pe(r) {
  return structuredClone(r);
}
class g {
  constructor(e, t) {
    I(this, "service");
    I(this, "filtersHostBridge");
    I(this, "_draftTree");
    I(this, "_filters");
    I(this, "expandedWellIds");
    I(this, "expandedFactWellIds");
    I(this, "expandedPlanWellIds");
    I(this, "expandedDesignKeys");
    I(this, "expandedWellboreKeys");
    I(this, "rootExpanded", !0);
    I(this, "primaryExpanded", !0);
    I(this, "searchValue", "");
    var n, i;
    this.service = e, this.filtersHostBridge = (n = t == null ? void 0 : t.filtersHostBridge) != null ? n : null, this._filters = ue((i = t == null ? void 0 : t.initialFilters) != null ? i : null), this._draftTree = j(e.selectedTree), this.expandedWellIds = T.set(), this.expandedFactWellIds = T.set(), this.expandedPlanWellIds = T.set(), this.expandedDesignKeys = T.set(), this.expandedWellboreKeys = T.set(), Se(this), this._filters && !he(this._filters) && this.commitPrunedSelection(this._draftTree);
  }
  setFiltersHostBridge(e) {
    this.filtersHostBridge = e;
  }
  get filters() {
    return this._filters;
  }
  get wellsSourceAllWells() {
    return this.service.wellsSourceRef.allWells;
  }
  get hasFiltersHost() {
    var e, t;
    return (t = (e = this.filtersHostBridge) == null ? void 0 : e.hasFiltersWidget) != null ? t : !1;
  }
  /** Versioned settings snapshot for gostorage (tree + filters). */
  getSettingsSnapshot() {
    return fe(this.service.selectedTree, this._filters);
  }
  get primaryWellId() {
    return this.service.primaryWellId;
  }
  get visibility() {
    return this.service.visibility;
  }
  get lockPrimaryWellSubtree() {
    return this.service.lockPrimaryWellSubtree;
  }
  get forcedPrimarySelection() {
    return this.service.forcedPrimarySelection;
  }
  isPrimarySubtreeLocked(e) {
    return this.lockPrimaryWellSubtree && e === this.primaryWellId;
  }
  isWellboreForced(e, t, n, i) {
    return ve(this.forcedPrimarySelection, e, t, n, i);
  }
  isTrajectoryForced(e, t, n, i, l) {
    return ze(this.forcedPrimarySelection, e, t, n, i, l);
  }
  isFactBranchForced(e) {
    return Mt(this.forcedPrimarySelection, e);
  }
  isPlanBranchForced(e) {
    return He(this.forcedPrimarySelection, e);
  }
  isDesignForced(e, t) {
    return Lt(this.forcedPrimarySelection, e, t);
  }
  setForcedPrimarySelection(e) {
    const t = this.service.forcedPrimarySelection;
    this.service.setForcedPrimarySelection(e);
    const n = Ye(
      this._draftTree,
      t,
      this.service.forcedPrimarySelection,
      (i) => this.service.getWellChildren(i)
    );
    this.setDraftTree(n);
  }
  get isLoading() {
    return this.service.wellsSourceRef.isLoading;
  }
  get selectedTree() {
    return this._draftTree;
  }
  get appliedTree() {
    return this.service.selectedTree;
  }
  get hasPendingSelectionChanges() {
    return !Qt(this._draftTree, this.service.selectedTree);
  }
  get catalogWells() {
    const e = this.service.primaryWellId, t = this.searchValue.trim().toLowerCase(), n = this._filters;
    return this.service.wellsSourceRef.allWells.filter((i) => i.id === e || !ct(i, n) ? !1 : t ? i.name.toLowerCase().includes(t) : !0);
  }
  get primaryWell() {
    var t;
    const e = this.service.primaryWellId;
    return W(e) && (t = this.service.wellsSourceRef.allWells.find((n) => n.id === e)) != null ? t : null;
  }
  get allCheckState() {
    return In(
      this.selectedTree,
      this.catalogWells.map((e) => e.id),
      (e) => this.service.getWellChildren(e),
      this.visibility
    );
  }
  get allChecked() {
    return B(this.allCheckState);
  }
  get allIntermediate() {
    return q(this.allCheckState);
  }
  get wellTreeRows() {
    const e = this.selectedTree, t = this.visibility;
    return this.catalogWells.map((n) => {
      const i = this.service.getWellChildren(n.id), l = e.wells.find((o) => o.wellId === n.id), s = $e(e, n.id, i, t);
      return {
        well: n,
        checkState: s,
        planCheckState: Oe(l, i, t),
        factCheckState: Be(l, i, t),
        expanded: this.expandedWellIds.has(n.id),
        children: i,
        hasVisibleChildren: ut(this.buildProjectedWellBranch(n.id, i))
      };
    }).sort(
      (n, i) => Xi(
        { checkState: n.checkState, name: n.well.name, status: n.well.status },
        { checkState: i.checkState, name: i.well.name, status: i.well.status }
      )
    );
  }
  getWellChildren(e) {
    return this.service.getWellChildren(e);
  }
  getForcedWellboreIdForWell(e) {
    const t = this.service.forcedPrimarySelection;
    return !t || t.wellId !== e ? null : t.wellboreId;
  }
  buildProjectedWellBranch(e, t = this.getWellChildren(e)) {
    return Hi(t, this.visibility, this._filters, this.getForcedWellboreIdForWell(e));
  }
  wellHasVisibleChildren(e) {
    return ut(this.buildProjectedWellBranch(e));
  }
  /**
   * UI projection for one well: which Fact/Plan/wellbore/traj nodes to render under visibility,
   * with checkbox state and tree sort order. Does not mutate catalog or selection.
   */
  getVisibleWellBranch(e) {
    const t = this.buildProjectedWellBranch(e), n = t.fact === null ? null : new Set(t.fact.map((o) => o.wellbore.id)), i = t.fact === null ? null : new Map(t.fact.map((o) => [o.wellbore.id, new Set(o.trajectories.map((a) => a.id))])), l = n === null ? null : this.getSortedFactWellbores(e).filter((o) => n.has(o.wellbore.id)).map(({ wellbore: o, checkState: a }) => {
      const c = i == null ? void 0 : i.get(o.id);
      return {
        wellbore: o,
        checkState: a,
        trajectories: this.getSortedTrajectories(e, o.id, "fact").filter(
          (u) => c == null ? void 0 : c.has(u.trajectory.id)
        )
      };
    }), s = t.plan === null ? null : this.getSortedPlanDesigns(e).map(({ design: o, checkState: a }) => {
      var h, m;
      const c = t.plan.find((f) => f.design.id === o.id), u = new Set((h = c == null ? void 0 : c.wellbores.map((f) => f.wellbore.id)) != null ? h : []), d = new Map(
        ((m = c == null ? void 0 : c.wellbores) != null ? m : []).map((f) => [
          f.wellbore.id,
          new Set(f.trajectories.map((S) => S.id))
        ])
      );
      return {
        design: o,
        checkState: a,
        wellbores: this.getSortedDesignWellbores(e, o.id).filter((f) => u.has(f.wellbore.id)).map(({ wellbore: f, checkState: S }) => {
          const _ = d.get(f.id);
          return {
            wellbore: f,
            checkState: S,
            trajectories: this.getSortedTrajectories(e, f.id, "plan", o.id).filter(
              (v) => _ == null ? void 0 : _.has(v.trajectory.id)
            )
          };
        })
      };
    });
    return {
      fact: l,
      plan: s,
      showFactGroup: t.showFactGroup,
      showPlanGroup: t.showPlanGroup
    };
  }
  isFactExpanded(e) {
    return this.expandedFactWellIds.has(e);
  }
  isPlanExpanded(e) {
    return this.expandedPlanWellIds.has(e);
  }
  isDesignExpanded(e, t) {
    return this.expandedDesignKeys.has(`${e}:design:${t}`);
  }
  isWellboreExpanded(e, t, n, i) {
    const l = t === "plan" && W(i) ? `${e}:plan:${i}:wb:${n}` : `${e}:fact:wb:${n}`;
    return this.expandedWellboreKeys.has(l);
  }
  getSortedFactWellbores(e) {
    const t = this.service.getWellChildren(e), n = this.selectedTree.wells.find((o) => o.wellId === e), i = this.visibility, l = (n == null ? void 0 : n.fact) !== void 0 && n.fact.length === 0;
    if (!t)
      return [];
    const s = this.getForcedWellboreIdForWell(e);
    return t.factWellbores.filter(
      (o) => s != null && o.id === s || Ce(o, this._filters)
    ).map((o) => {
      const a = l ? "checked" : ye(
        n == null ? void 0 : n.fact,
        o.id,
        o.trajectories.map((c) => c.id),
        i.showTrajectories
      );
      return { wellbore: o, checkState: a };
    }).sort(
      (o, a) => yt(
        {
          checkState: o.checkState,
          name: o.wellbore.name,
          isActive: o.wellbore.isActive,
          typeSlug: o.wellbore.typeSlug,
          typeIndex: o.wellbore.typeIndex,
          redrillingIndex: o.wellbore.redrillingIndex
        },
        {
          checkState: a.checkState,
          name: a.wellbore.name,
          isActive: a.wellbore.isActive,
          typeSlug: a.wellbore.typeSlug,
          typeIndex: a.wellbore.typeIndex,
          redrillingIndex: a.wellbore.redrillingIndex
        }
      )
    );
  }
  getSortedPlanDesigns(e) {
    const t = this.service.getWellChildren(e), n = this.selectedTree.wells.find((s) => s.wellId === e), i = this.visibility, l = (n == null ? void 0 : n.plan) !== void 0 && n.plan.length === 0;
    return t ? t.planDesigns.map((s) => ({
      design: s,
      checkState: l ? "checked" : Le(
        n == null ? void 0 : n.plan,
        s.id,
        s.wellbores,
        i.showTrajectories,
        i.showWellbores
      )
    })).sort(
      (s, o) => gt(
        { checkState: s.checkState, name: s.design.name, isActive: s.design.isActive },
        { checkState: o.checkState, name: o.design.name, isActive: o.design.isActive }
      )
    ) : [];
  }
  getSortedDesignWellbores(e, t) {
    var u;
    const n = this.service.getWellChildren(e), i = this.selectedTree.wells.find((d) => d.wellId === e), l = n == null ? void 0 : n.planDesigns.find((d) => d.id === t), s = (u = i == null ? void 0 : i.plan) == null ? void 0 : u.find((d) => d.designId === t), o = this.visibility;
    if (!l)
      return [];
    const a = (i == null ? void 0 : i.plan) !== void 0 && i.plan.length === 0 || s == null ? void 0 : s.wellbores, c = this.getForcedWellboreIdForWell(e);
    return l.wellbores.filter(
      (d) => c != null && d.id === c || Ce(d, this._filters)
    ).map((d) => {
      const h = (i == null ? void 0 : i.plan) !== void 0 && i.plan.length === 0, m = s !== void 0 && s.wellbores.length === 0;
      let f;
      return h || m ? f = "checked" : f = ye(
        a,
        d.id,
        d.trajectories.map((S) => S.id),
        o.showTrajectories
      ), { wellbore: d, checkState: f };
    }).sort(
      (d, h) => yt(
        {
          checkState: d.checkState,
          name: d.wellbore.name,
          isActive: d.wellbore.isActive,
          typeSlug: d.wellbore.typeSlug,
          typeIndex: d.wellbore.typeIndex,
          redrillingIndex: d.wellbore.redrillingIndex
        },
        {
          checkState: h.checkState,
          name: h.wellbore.name,
          isActive: h.wellbore.isActive,
          typeSlug: h.wellbore.typeSlug,
          typeIndex: h.wellbore.typeIndex,
          redrillingIndex: h.wellbore.redrillingIndex
        }
      )
    );
  }
  getSortedTrajectories(e, t, n, i) {
    var d;
    const l = this.service.getWellChildren(e), s = this.selectedTree.wells.find((h) => h.wellId === e);
    let o, a;
    if (n === "fact")
      o = l == null ? void 0 : l.factWellbores.find((h) => h.id === t), a = s == null ? void 0 : s.fact;
    else if (W(i)) {
      const h = l == null ? void 0 : l.planDesigns.find((_) => _.id === i);
      o = h == null ? void 0 : h.wellbores.find((_) => _.id === t);
      const m = (d = s == null ? void 0 : s.plan) == null ? void 0 : d.find((_) => _.designId === i), f = (s == null ? void 0 : s.plan) !== void 0 && s.plan.length === 0, S = m !== void 0 && m.wellbores.length === 0;
      f || S ? a = o ? [{ wellboreId: t, trajectories: [] }] : void 0 : a = m == null ? void 0 : m.wellbores;
    }
    if (!o)
      return [];
    const u = (s == null ? void 0 : s.fact) !== void 0 && s.fact.length === 0 ? [{ wellboreId: t, trajectories: [] }] : a;
    return o.trajectories.map((h) => ({
      trajectory: h,
      checkState: yn(u, t, h.id)
    })).sort(
      (h, m) => gt(
        {
          checkState: h.checkState,
          name: h.trajectory.name,
          isActive: h.trajectory.isActive
        },
        {
          checkState: m.checkState,
          name: m.trajectory.name,
          isActive: m.trajectory.isActive
        }
      )
    );
  }
  setSearchValue(e) {
    this.searchValue = e;
  }
  setAllWellChildren(e) {
    this.service.setAllWellChildren(e), this.setDraftTree(this._draftTree), this._filters && !he(this._filters) && this.commitPrunedSelection(this._draftTree);
  }
  syncDraftFromApplied() {
    this._draftTree = j(this.service.selectedTree);
  }
  applyDraftSelection() {
    this.commitPrunedSelection(this._draftTree);
  }
  applySettingsFromGroup(e) {
    this._filters = ue(e.filters), this._draftTree = j(e.tree), this.applyDraftSelection();
  }
  resetDraftSelection() {
    this._draftTree = j(this.service.selectedTree);
  }
  importFiltersFromHost() {
    var e;
    (e = this.filtersHostBridge) != null && e.hasFiltersWidget && (this._filters = ue(this.filtersHostBridge.pullFilters()), this.applyDraftSelection());
  }
  exportFiltersToHost() {
    var e;
    !((e = this.filtersHostBridge) != null && e.hasFiltersWidget) || this._filters === null || this.filtersHostBridge.pushFilters(ue(this._filters));
  }
  /** Prune by current filters and commit to service + draft. */
  commitPrunedSelection(e) {
    const t = this.pruneTreeByWellsFilters(e);
    this.service.setSelectedTree(t), this._draftTree = j(this.service.selectedTree);
  }
  /**
   * Drop non-primary wells that do not pass well filters, and prune wellbores
   * that do not pass wellboreTypeInstanceId (forced/primary wellbores kept).
   */
  pruneTreeByWellsFilters(e) {
    const t = this._filters;
    if (!t || he(t))
      return j(e);
    const n = new Map(this.service.wellsSourceRef.allWells.map((o) => [o.id, o])), i = this.service.primaryWellId, l = this.service.forcedPrimarySelection;
    return { wells: e.wells.filter((o) => {
      if (o.wellId === i)
        return !0;
      const a = n.get(o.wellId);
      return a ? ct(a, t) : !1;
    }).map((o) => this.pruneWellSelectionByWellboreFilters(o, t, l)) };
  }
  pruneWellSelectionByWellboreFilters(e, t, n) {
    var o;
    if (t.wellboreTypeInstanceId.length === 0)
      return structuredClone(e);
    const i = this.service.getWellChildren(e.wellId), l = (a, c, u) => {
      var h;
      if (n && ve(n, e.wellId, c, a, u))
        return !0;
      const d = c === "fact" ? i == null ? void 0 : i.factWellbores.find((m) => m.id === a) : (h = i == null ? void 0 : i.planDesigns.find((m) => m.id === u)) == null ? void 0 : h.wellbores.find((m) => m.id === a);
      return d ? Ce(d, t) : i == null;
    }, s = { wellId: e.wellId };
    if (e.fact !== void 0)
      if (e.fact.length === 0)
        if (!i)
          s.fact = [];
        else {
          const a = i.factWellbores.filter((c) => l(c.id, "fact")).map((c) => ({ wellboreId: c.id, trajectories: [] }));
          a.length === 0 || (a.length === i.factWellbores.length ? s.fact = [] : s.fact = a);
        }
      else {
        const a = e.fact.filter((c) => l(c.wellboreId, "fact"));
        a.length > 0 && (s.fact = a.map((c) => structuredClone(c)));
      }
    if (e.plan !== void 0)
      if (e.plan.length === 0)
        if (!i)
          s.plan = [];
        else {
          const a = i.planDesigns.map((c) => {
            const u = c.wellbores.filter((d) => l(d.id, "plan", c.id)).map((d) => ({ wellboreId: d.id, trajectories: [] }));
            return u.length === 0 ? null : u.length === c.wellbores.length ? { designId: c.id, wellbores: [] } : { designId: c.id, wellbores: u };
          }).filter((c) => c !== null);
          a.length > 0 && (s.plan = a.length === i.planDesigns.length && a.every((c) => c.wellbores.length === 0) ? [] : a);
        }
      else {
        const a = [];
        for (const c of e.plan)
          if (c.wellbores.length === 0) {
            const u = i == null ? void 0 : i.planDesigns.find((h) => h.id === c.designId), d = (o = u == null ? void 0 : u.wellbores.filter((h) => l(h.id, "plan", c.designId)).map((h) => ({ wellboreId: h.id, trajectories: [] }))) != null ? o : [];
            if (d.length === 0)
              continue;
            u && d.length === u.wellbores.length ? a.push({ designId: c.designId, wellbores: [] }) : a.push({ designId: c.designId, wellbores: d });
          } else {
            const u = c.wellbores.filter((d) => l(d.wellboreId, "plan", c.designId));
            u.length > 0 && a.push({
              designId: c.designId,
              wellbores: u.map((d) => structuredClone(d))
            });
          }
        a.length > 0 && (s.plan = a);
      }
    return s;
  }
  togglePrimaryExpanded() {
    this.primaryExpanded = !this.primaryExpanded;
  }
  toggleRootExpanded() {
    this.rootExpanded = !this.rootExpanded;
  }
  toggleWellExpanded(e) {
    this.expandedWellIds.has(e) ? this.expandedWellIds.delete(e) : this.expandedWellIds.add(e);
  }
  toggleFactExpanded(e) {
    this.expandedFactWellIds.has(e) ? this.expandedFactWellIds.delete(e) : this.expandedFactWellIds.add(e);
  }
  togglePlanExpanded(e) {
    this.expandedPlanWellIds.has(e) ? this.expandedPlanWellIds.delete(e) : this.expandedPlanWellIds.add(e);
  }
  toggleDesignExpanded(e, t) {
    const n = `${e}:design:${t}`;
    this.expandedDesignKeys.has(n) ? this.expandedDesignKeys.delete(n) : this.expandedDesignKeys.add(n);
  }
  toggleWellboreExpanded(e, t, n, i) {
    const l = t === "plan" && W(i) ? `${e}:plan:${i}:wb:${n}` : `${e}:fact:wb:${n}`;
    this.expandedWellboreKeys.has(l) ? this.expandedWellboreKeys.delete(l) : this.expandedWellboreKeys.add(l);
  }
  setAllChecked(e) {
    const t = this.service.primaryWellId, n = W(t) ? this.selectedTree.wells.find((o) => o.wellId === t) : void 0, i = n ? pe(n) : void 0;
    if (!e) {
      this.setDraftTree({ wells: i ? [i] : [] });
      return;
    }
    const l = this.visibility, s = this.catalogWells.map((o) => {
      const a = { wellId: o.id };
      return l.showFact && (a.fact = []), l.showPlan && (a.plan = []), a;
    });
    i && s.push(i), this.setDraftTree({ wells: s });
  }
  setWellChecked(e, t) {
    if (this.isPrimarySubtreeLocked(e))
      return;
    const n = this.selectedTree.wells.filter((i) => i.wellId !== e);
    if (t) {
      const i = { wellId: e }, l = this.visibility;
      l.showFact && (i.fact = []), l.showPlan && (i.plan = []), n.push(i);
    }
    this.setDraftTree({ wells: n });
  }
  setFactChecked(e, t) {
    if (this.isPrimarySubtreeLocked(e))
      return;
    const n = this.selectedTree.wells.map(pe);
    let i = n.find((l) => l.wellId === e);
    if (!i) {
      if (!t)
        return;
      i = { wellId: e }, n.push(i);
    }
    if (t)
      i.fact = [];
    else {
      delete i.fact;
      const l = this.forcedPrimarySelection;
      (l == null ? void 0 : l.wellId) === e && l.branch === "fact" && Object.assign(i, it(i, l, this.service.getWellChildren(e)));
    }
    this.commitWells(n);
  }
  setPlanChecked(e, t) {
    if (this.isPrimarySubtreeLocked(e))
      return;
    const n = this.selectedTree.wells.map(pe);
    let i = n.find((l) => l.wellId === e);
    if (!i) {
      if (!t)
        return;
      i = { wellId: e }, n.push(i);
    }
    if (t)
      i.plan = [];
    else {
      delete i.plan;
      const l = this.forcedPrimarySelection;
      (l == null ? void 0 : l.wellId) === e && l.branch === "plan" && Object.assign(i, it(i, l, this.service.getWellChildren(e)));
    }
    this.commitWells(n);
  }
  setFactWellboreChecked(e, t, n) {
    this.isPrimarySubtreeLocked(e) || !n && this.isWellboreForced(e, "fact", t) || this.updateFactWellbores(e, (i, l) => {
      const s = i.filter((o) => o.wellboreId !== t);
      return n ? (s.push({ wellboreId: t, trajectories: [] }), l && s.length === l.factWellbores.length && s.every((a) => a.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: s }) : s.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: s };
    });
  }
  setFactTrajectoryChecked(e, t, n, i) {
    this.isPrimarySubtreeLocked(e) || !i && this.isTrajectoryForced(e, "fact", t, n) || this.updateFactWellbores(e, (l, s) => {
      var m;
      const o = s == null ? void 0 : s.factWellbores.find((f) => f.id === t), a = (m = o == null ? void 0 : o.trajectories.map((f) => f.id)) != null ? m : [], c = l.find((f) => f.wellboreId === t), u = new Set(
        c ? c.trajectories.length === 0 ? a : c.trajectories.map((f) => f.trajectoryId) : []
      );
      i ? u.add(n) : u.delete(n);
      const d = l.filter((f) => f.wellboreId !== t);
      if (u.size === 0)
        return d.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: d };
      const h = a.length > 0 && u.size === a.length ? [] : Array.from(u).map((f) => ({ trajectoryId: f }));
      return d.push({ wellboreId: t, trajectories: h }), s && d.length === s.factWellbores.length && d.every((S) => S.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: d };
    });
  }
  setDesignChecked(e, t, n) {
    this.isPrimarySubtreeLocked(e) || this.updatePlanDesigns(e, (i, l) => {
      const s = i.filter((o) => o.designId !== t);
      if (!n) {
        const o = this.forcedPrimarySelection;
        return (o == null ? void 0 : o.wellId) === e && o.branch === "plan" && o.designId === t ? (s.push({
          designId: t,
          wellbores: [
            {
              wellboreId: o.wellboreId,
              trajectories: W(o.trajectoryId) ? [{ trajectoryId: o.trajectoryId }] : []
            }
          ]
        }), { kind: "partial", designs: s }) : s.length === 0 ? { kind: "none" } : { kind: "partial", designs: s };
      }
      return s.push({ designId: t, wellbores: [] }), l && s.length === l.planDesigns.length && s.every((a) => a.wellbores.length === 0) ? { kind: "whole" } : { kind: "partial", designs: s };
    });
  }
  setPlanWellboreChecked(e, t, n, i) {
    this.isPrimarySubtreeLocked(e) || !i && this.isWellboreForced(e, "plan", n, t) || this.updatePlanDesignWellbores(e, t, (l, s) => {
      const o = l.filter((a) => a.wellboreId !== n);
      return i ? (o.push({ wellboreId: n, trajectories: [] }), s && o.length === s.wellbores.length && o.every((c) => c.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: o }) : o.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: o };
    });
  }
  setPlanTrajectoryChecked(e, t, n, i, l) {
    this.isPrimarySubtreeLocked(e) || !l && this.isTrajectoryForced(e, "plan", n, i, t) || this.updatePlanDesignWellbores(e, t, (s, o) => {
      var f;
      const a = o == null ? void 0 : o.wellbores.find((S) => S.id === n), c = (f = a == null ? void 0 : a.trajectories.map((S) => S.id)) != null ? f : [], u = s.find((S) => S.wellboreId === n), d = new Set(
        u ? u.trajectories.length === 0 ? c : u.trajectories.map((S) => S.trajectoryId) : []
      );
      l ? d.add(i) : d.delete(i);
      const h = s.filter((S) => S.wellboreId !== n);
      if (d.size === 0)
        return h.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: h };
      const m = c.length > 0 && d.size === c.length ? [] : Array.from(d).map((S) => ({ trajectoryId: S }));
      return h.push({ wellboreId: n, trajectories: m }), o && h.length === o.wellbores.length && h.every((_) => _.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: h };
    });
  }
  updateFactWellbores(e, t) {
    var a;
    const n = this.selectedTree.wells.map(pe);
    let i = n.find((c) => c.wellId === e);
    const l = this.service.getWellChildren(e);
    i || (i = { wellId: e }, n.push(i));
    const s = i.fact === void 0 ? [] : i.fact.length === 0 ? (a = l == null ? void 0 : l.factWellbores.map((c) => ({ wellboreId: c.id, trajectories: [] }))) != null ? a : [] : i.fact, o = t(
      s.map((c) => structuredClone(c)),
      l
    );
    o.kind === "whole" ? i.fact = [] : o.kind === "none" ? delete i.fact : i.fact = o.wellbores, this.commitWells(n);
  }
  updatePlanDesigns(e, t) {
    var a;
    const n = this.selectedTree.wells.map(pe);
    let i = n.find((c) => c.wellId === e);
    const l = this.service.getWellChildren(e);
    i || (i = { wellId: e }, n.push(i));
    const s = i.plan === void 0 ? [] : i.plan.length === 0 ? (a = l == null ? void 0 : l.planDesigns.map((c) => ({
      designId: c.id,
      wellbores: []
    }))) != null ? a : [] : i.plan, o = t(
      s.map((c) => structuredClone(c)),
      l
    );
    o.kind === "whole" ? i.plan = [] : o.kind === "none" ? delete i.plan : i.plan = o.designs, this.commitWells(n);
  }
  updatePlanDesignWellbores(e, t, n) {
    this.updatePlanDesigns(e, (i, l) => {
      var d;
      const s = l == null ? void 0 : l.planDesigns.find((h) => h.id === t), o = i.find((h) => h.designId === t), a = o ? o.wellbores.length === 0 ? (d = s == null ? void 0 : s.wellbores.map((h) => ({ wellboreId: h.id, trajectories: [] }))) != null ? d : [] : o.wellbores : [], c = n(
        a.map((h) => structuredClone(h)),
        s
      ), u = i.filter((h) => h.designId !== t);
      return c.kind === "none" ? u.length === 0 ? { kind: "none" } : { kind: "partial", designs: u } : (c.kind === "whole" ? u.push({ designId: t, wellbores: [] }) : u.push({ designId: t, wellbores: c.wellbores }), l && u.length === l.planDesigns.length && u.every((m) => m.wellbores.length === 0) ? { kind: "whole" } : { kind: "partial", designs: u });
    });
  }
  commitWells(e) {
    const t = e.filter((n) => n.fact !== void 0 || n.plan !== void 0);
    this.setDraftTree({ wells: t });
  }
  setDraftTree(e) {
    const t = At(
      e,
      (n) => this.service.getWellChildren(n),
      this.visibility
    );
    this._draftTree = j(t);
  }
}
b([
  T.ref
], g.prototype, "_draftTree", 2);
b([
  T.ref
], g.prototype, "_filters", 2);
b([
  T
], g.prototype, "expandedWellIds", 2);
b([
  T
], g.prototype, "expandedFactWellIds", 2);
b([
  T
], g.prototype, "expandedPlanWellIds", 2);
b([
  T
], g.prototype, "expandedDesignKeys", 2);
b([
  T
], g.prototype, "expandedWellboreKeys", 2);
b([
  T
], g.prototype, "rootExpanded", 2);
b([
  T
], g.prototype, "primaryExpanded", 2);
b([
  T
], g.prototype, "searchValue", 2);
b([
  y.bound
], g.prototype, "setFiltersHostBridge", 1);
b([
  w
], g.prototype, "filters", 1);
b([
  w
], g.prototype, "wellsSourceAllWells", 1);
b([
  w
], g.prototype, "hasFiltersHost", 1);
b([
  w
], g.prototype, "primaryWellId", 1);
b([
  w
], g.prototype, "visibility", 1);
b([
  w
], g.prototype, "forcedPrimarySelection", 1);
b([
  y.bound
], g.prototype, "setForcedPrimarySelection", 1);
b([
  w
], g.prototype, "isLoading", 1);
b([
  w
], g.prototype, "selectedTree", 1);
b([
  w
], g.prototype, "appliedTree", 1);
b([
  w
], g.prototype, "hasPendingSelectionChanges", 1);
b([
  w
], g.prototype, "catalogWells", 1);
b([
  w
], g.prototype, "primaryWell", 1);
b([
  w
], g.prototype, "allCheckState", 1);
b([
  w
], g.prototype, "allChecked", 1);
b([
  w
], g.prototype, "allIntermediate", 1);
b([
  w
], g.prototype, "wellTreeRows", 1);
b([
  y.bound
], g.prototype, "setSearchValue", 1);
b([
  y.bound
], g.prototype, "setAllWellChildren", 1);
b([
  y.bound
], g.prototype, "syncDraftFromApplied", 1);
b([
  y.bound
], g.prototype, "applyDraftSelection", 1);
b([
  y.bound
], g.prototype, "applySettingsFromGroup", 1);
b([
  y.bound
], g.prototype, "resetDraftSelection", 1);
b([
  y.bound
], g.prototype, "importFiltersFromHost", 1);
b([
  y.bound
], g.prototype, "exportFiltersToHost", 1);
b([
  y.bound
], g.prototype, "togglePrimaryExpanded", 1);
b([
  y.bound
], g.prototype, "toggleRootExpanded", 1);
b([
  y.bound
], g.prototype, "toggleWellExpanded", 1);
b([
  y.bound
], g.prototype, "toggleFactExpanded", 1);
b([
  y.bound
], g.prototype, "togglePlanExpanded", 1);
b([
  y.bound
], g.prototype, "toggleDesignExpanded", 1);
b([
  y.bound
], g.prototype, "toggleWellboreExpanded", 1);
b([
  y.bound
], g.prototype, "setAllChecked", 1);
b([
  y.bound
], g.prototype, "setWellChecked", 1);
b([
  y.bound
], g.prototype, "setFactChecked", 1);
b([
  y.bound
], g.prototype, "setPlanChecked", 1);
b([
  y.bound
], g.prototype, "setFactWellboreChecked", 1);
b([
  y.bound
], g.prototype, "setFactTrajectoryChecked", 1);
b([
  y.bound
], g.prototype, "setDesignChecked", 1);
b([
  y.bound
], g.prototype, "setPlanWellboreChecked", 1);
b([
  y.bound
], g.prototype, "setPlanTrajectoryChecked", 1);
b([
  y
], g.prototype, "setDraftTree", 1);
var qi = Object.defineProperty, Qi = Object.getOwnPropertyDescriptor, De = (r, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? Qi(e, t) : e, l = r.length - 1, s; l >= 0; l--)
    (s = r[l]) && (i = (n ? s(e, t, i) : s(i)) || i);
  return n && i && qi(e, t, i), i;
};
class Ee {
  constructor(e) {
    I(this, "api");
    I(this, "referenceWellsStore");
    I(this, "isLoading", !1);
    I(this, "error", null);
    this.api = e.api, this.referenceWellsStore = e.referenceWellsStore, Se(this);
  }
  *load() {
    this.isLoading = !0, this.error = null;
    try {
      const e = yield this.api.fetchChildren();
      this.referenceWellsStore.setAllWellChildren(e);
    } catch (e) {
      console.error(e), this.error = e;
    } finally {
      this.isLoading = !1;
    }
  }
  dispose() {
    this.error = null, this.isLoading = !1;
  }
}
De([
  T
], Ee.prototype, "isLoading", 2);
De([
  T
], Ee.prototype, "error", 2);
De([
  U.bound
], Ee.prototype, "load", 1);
De([
  y.bound
], Ee.prototype, "dispose", 1);
const Sl = ["Common_WellboreType", "Common_WellboreTypeInstance"];
function zt(r) {
  return (r != null ? r : "").toString().trim().toLowerCase();
}
function Te(r) {
  const e = typeof r == "number" ? r : Number(r);
  return Number.isFinite(e) ? e : null;
}
function el(r, e) {
  const t = /* @__PURE__ */ new Map();
  if (!(r != null && r.length) || !(e != null && e.length))
    return t;
  const n = /* @__PURE__ */ new Map();
  for (const i of r) {
    const l = Te(i.id);
    l != null && n.set(l, i);
  }
  for (const i of e) {
    const l = Te(i.data.typeId), s = Te(i.data.index), o = Te(i.id), a = i.data.name;
    if (l == null || s == null || o == null || a == null)
      continue;
    const c = n.get(l);
    if (!c)
      continue;
    const u = zt(typeof c.data.slug == "string" ? c.data.slug : void 0);
    u && t.set(`${u}:${s}`, {
      typeId: l,
      typeInstanceId: o,
      typeInstanceName: String(a)
    });
  }
  return t;
}
function Ht(r, e) {
  const t = `${zt(r.typeSlug)}:${r.typeIndex}`, n = e.get(t);
  return n ? {
    ...r,
    typeId: n.typeId,
    typeInstanceId: n.typeInstanceId,
    typeInstanceName: n.typeInstanceName
  } : r;
}
function tl(r, e) {
  return {
    ...r,
    wellbores: r.wellbores.map((t) => Ht(t, e))
  };
}
function nl(r, e) {
  return {
    factWellbores: r.factWellbores.map((t) => Ht(t, e)),
    planDesigns: r.planDesigns.map((t) => tl(t, e))
  };
}
function rl(r, e) {
  const t = /* @__PURE__ */ new Map();
  for (const [n, i] of r)
    t.set(n, nl(i, e));
  return t;
}
function wl(r, e) {
  return {
    async fetchChildren() {
      const [t, n] = await Promise.all([r.fetchChildren(), e()]);
      return rl(
        t,
        el(n.types, n.instances)
      );
    }
  };
}
async function _l({
  wellId: r,
  childrenStore: e,
  templatesStore: t
}) {
  await Promise.all([e.load(), t.loadTemplatesForWell(r)]);
}
function Wl({
  wellsService: r,
  hasAssignedGroup: e,
  onCommittedSelection: t
}) {
  return e || !r.ensureDefaultPrimaryWellboreSelection() ? !1 : (t == null || t(), !0);
}
const It = 1, il = 0.1;
function ll(r, e) {
  const t = r.isFavorite ? It : 0, n = e.isFavorite ? It : 0, i = r.name.localeCompare(e.name, void 0, { sensitivity: "base" }) * il;
  return n - t + i;
}
var sl = Object.defineProperty, ol = Object.getOwnPropertyDescriptor, k = (r, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? ol(e, t) : e, l = r.length - 1, s; l >= 0; l--)
    (s = r[l]) && (i = (n ? s(e, t, i) : s(i)) || i);
  return n && i && sl(e, t, i), i;
};
function vt() {
  return crypto.randomUUID();
}
function St(r) {
  const e = me(r.tree);
  return {
    ...r,
    tree: fe(e.tree, e.filters)
  };
}
function wt(r) {
  return r != null && r.data ? r.data.type === "public" ? {
    ...r,
    data: {
      ...r.data,
      templates: r.data.templates.map(St)
    }
  } : r.data.type === "personal" ? {
    ...r,
    data: {
      ...r.data,
      templates: r.data.templates.map(St)
    }
  } : r : r;
}
function Ne(r, e) {
  return {
    id: r.id,
    data: e,
    status: "ACTIVE",
    objectType: r.objectType
  };
}
class P {
  constructor(e) {
    I(this, "api");
    I(this, "wellsService");
    I(this, "getOwnerUserId");
    I(this, "getDraftTree");
    I(this, "getDraftFilters");
    I(this, "applyReferenceWellsSettings");
    I(this, "onCommittedSelection");
    I(this, "groupFavorites");
    I(this, "publicDoc", null);
    I(this, "personalDoc", null);
    I(this, "isLoading", !1);
    I(this, "isSaving", !1);
    I(this, "saveModalOpen", !1);
    I(this, "renameTarget", null);
    this.api = e.api, this.wellsService = e.wellsService, this.getOwnerUserId = e.getOwnerUserId, this.getDraftTree = e.getDraftTree, this.getDraftFilters = e.getDraftFilters, this.applyReferenceWellsSettings = e.applyReferenceWellsSettings, this.onCommittedSelection = e.onCommittedSelection, this.groupFavorites = e.groupFavorites, Se(this);
  }
  get publicGroups() {
    var t, n;
    const e = ((n = (t = this.publicDoc) == null ? void 0 : t.data) == null ? void 0 : n.type) === "public" ? this.publicDoc.data.templates : [];
    return this.mapAndSortGroups(e, "public");
  }
  get personalGroups() {
    var t, n;
    const e = ((n = (t = this.personalDoc) == null ? void 0 : t.data) == null ? void 0 : n.type) === "personal" ? this.personalDoc.data.templates : [];
    return this.mapAndSortGroups(e, "personal");
  }
  get lastAppliedTemplateId() {
    var e, t;
    return ((t = (e = this.personalDoc) == null ? void 0 : e.data) == null ? void 0 : t.type) !== "personal" ? null : this.personalDoc.data.lastAppliedTemplateId;
  }
  get hasRestorableLastAppliedGroup() {
    var t;
    const e = this.lastAppliedTemplateId;
    return W(e) ? !!((t = this.findTemplate(e, "personal")) != null ? t : this.findTemplate(e, "public")) : !1;
  }
  get hasAnyGroups() {
    return this.publicGroups.length > 0 || this.personalGroups.length > 0;
  }
  get canCreate() {
    return W(this.wellsService.primaryWellId) && !this.isLoading;
  }
  openSaveModal() {
    this.saveModalOpen = !0;
  }
  closeSaveModal() {
    this.saveModalOpen = !1;
  }
  openRenameModal(e) {
    this.renameTarget = e;
  }
  closeRenameModal() {
    this.renameTarget = null;
  }
  toggleGroupFavorite(e) {
    var t;
    (t = this.groupFavorites) == null || t.toggleFavorite(e);
  }
  isGroupFavorite(e) {
    var t, n;
    return (n = (t = this.groupFavorites) == null ? void 0 : t.isFavorite(e)) != null ? n : !1;
  }
  *loadTemplatesForWell(e) {
    var t, n;
    if (!W(e)) {
      this.publicDoc = null, this.personalDoc = null;
      return;
    }
    this.isLoading = !0;
    try {
      const i = this.getOwnerUserId(), [l, s] = yield Promise.all([this.api.listPublic(e), this.api.listPersonal(e, i)]);
      this.publicDoc = wt((t = l[0]) != null ? t : null), this.personalDoc = wt((n = s[0]) != null ? n : null);
    } catch (i) {
      console.error(i), this.publicDoc = null, this.personalDoc = null;
    } finally {
      this.isLoading = !1;
    }
  }
  *reloadForWellChange(e) {
    this.commitSelectedTree(Ie()), yield this.loadTemplatesForWell(e), this.restoreLastApplied();
  }
  *createGroupFromCurrentSelection(e, t, n = "") {
    yield this.createGroupWithTree(e, t, this.getSelectionTreeForSave(), n);
  }
  *createGroupWithTree(e, t, n, i = "") {
    const l = this.wellsService.primaryWellId;
    if (!W(l))
      return;
    const s = e.trim();
    if (s) {
      this.isSaving = !0;
      try {
        const o = i.trim(), a = {
          id: vt(),
          name: s,
          ...o ? { description: o } : {},
          tree: fe(n, this.getFiltersForSave())
        };
        t === "public" ? yield this.appendTemplateToPublic(l, a) : yield this.appendTemplateToPersonal(l, a), this.saveModalOpen = !1;
      } catch (o) {
        console.error(o);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *renameGroup(e, t, n, i = "") {
    const l = n.trim();
    if (l) {
      this.isSaving = !0;
      try {
        const s = i.trim();
        yield this.updateTemplateFields(e, t, (o) => {
          const a = {
            ...o,
            name: l
          };
          return s ? a.description = s : delete a.description, a;
        }), this.renameTarget = null;
      } catch (s) {
        console.error(s);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *updateGroupWithCurrentTree(e, t) {
    this.isSaving = !0;
    try {
      const n = fe(this.getSelectionTreeForSave(), this.getFiltersForSave());
      yield this.updateTemplateFields(e, t, (i) => ({
        ...i,
        tree: n
      })), this.saveModalOpen = !1;
    } catch (n) {
      console.error(n);
    } finally {
      this.isSaving = !1;
    }
  }
  *applyGroup(e, t) {
    const n = this.findTemplate(e, t);
    if (n) {
      this.isSaving = !0;
      try {
        this.commitGroupSettings(me(n.tree)), yield this.setLastAppliedTemplateId(e);
      } catch (i) {
        console.error(i);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *duplicateGroup(e, t) {
    const n = this.findTemplate(e, t), i = this.wellsService.primaryWellId;
    if (!(!n || !W(i))) {
      this.isSaving = !0;
      try {
        const l = me(n.tree), s = {
          id: vt(),
          name: n.name,
          ...n.description ? { description: n.description } : {},
          tree: fe(l.tree, l.filters)
        };
        (t === "public" ? "personal" : "public") === "public" ? yield this.appendTemplateToPublic(i, s) : yield this.appendTemplateToPersonal(i, s);
      } catch (l) {
        console.error(l);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *deleteGroup(e, t) {
    this.isSaving = !0;
    try {
      if (t === "public") {
        const s = this.publicDoc;
        if (!s || s.data.type !== "public")
          return;
        const o = s.data.templates.filter((c) => c.id !== e), a = {
          ...s.data,
          templates: o
        };
        o.length === 0 ? (yield this.api.delete(s.id), this.publicDoc = null) : (yield this.api.update(s.id, a), this.publicDoc = { ...s, data: a });
        return;
      }
      const n = this.personalDoc;
      if (!n || n.data.type !== "personal")
        return;
      const i = n.data.templates.filter((s) => s.id !== e), l = {
        ...n.data,
        templates: i,
        lastAppliedTemplateId: n.data.lastAppliedTemplateId === e ? null : n.data.lastAppliedTemplateId
      };
      i.length === 0 && !W(l.lastAppliedTemplateId) ? (yield this.api.delete(n.id), this.personalDoc = null) : (yield this.api.update(n.id, l), this.personalDoc = { ...n, data: l });
    } catch (n) {
      console.error(n);
    } finally {
      this.isSaving = !1;
    }
  }
  restoreLastApplied() {
    var n, i, l;
    if (((i = (n = this.personalDoc) == null ? void 0 : n.data) == null ? void 0 : i.type) !== "personal")
      return;
    const e = this.personalDoc.data.lastAppliedTemplateId;
    if (!W(e))
      return;
    const t = (l = this.findTemplate(e, "personal")) != null ? l : this.findTemplate(e, "public");
    t && this.commitGroupSettings(me(t.tree));
  }
  mapAndSortGroups(e, t) {
    var n;
    return (n = this.groupFavorites) == null || n.favoriteIds, e.map((i) => {
      var l, s;
      return {
        id: i.id,
        name: i.name,
        description: i.description,
        visibility: t,
        isFavorite: (s = (l = this.groupFavorites) == null ? void 0 : l.isFavorite(i.id)) != null ? s : !1
      };
    }).sort(ll);
  }
  getSelectionTreeForSave() {
    var e, t;
    return (t = (e = this.getDraftTree) == null ? void 0 : e.call(this)) != null ? t : this.wellsService.selectedTree;
  }
  getFiltersForSave() {
    var e, t;
    return (t = (e = this.getDraftFilters) == null ? void 0 : e.call(this)) != null ? t : null;
  }
  /** Apply group envelope to RW (tree + filters). Falls back to tree-only commit. */
  commitGroupSettings(e) {
    var t;
    if (this.applyReferenceWellsSettings) {
      this.applyReferenceWellsSettings(e);
      return;
    }
    this.wellsService.setSelectedTree(e.tree), (t = this.onCommittedSelection) == null || t.call(this);
  }
  commitSelectedTree(e) {
    var t;
    this.wellsService.setSelectedTree(e), (t = this.onCommittedSelection) == null || t.call(this);
  }
  findTemplate(e, t) {
    var n, i, l, s;
    if (t === "public")
      return ((i = (n = this.publicDoc) == null ? void 0 : n.data) == null ? void 0 : i.type) !== "public" ? void 0 : this.publicDoc.data.templates.find((o) => o.id === e);
    if (((s = (l = this.personalDoc) == null ? void 0 : l.data) == null ? void 0 : s.type) === "personal")
      return this.personalDoc.data.templates.find((o) => o.id === e);
  }
  async appendTemplateToPublic(e, t) {
    const n = this.publicDoc;
    if (n && n.data.type === "public") {
      const s = {
        ...n.data,
        templates: [...n.data.templates, t]
      };
      await this.api.update(n.id, s), K(() => {
        this.publicDoc = { ...n, data: s };
      });
      return;
    }
    const i = {
      type: "public",
      wellId: e,
      templates: [t]
    }, l = await this.api.create(i);
    K(() => {
      this.publicDoc = Ne(l, i);
    });
  }
  async appendTemplateToPersonal(e, t) {
    const n = this.personalDoc, i = this.getOwnerUserId();
    if (n && n.data.type === "personal") {
      const o = {
        ...n.data,
        templates: [...n.data.templates, t]
      };
      await this.api.update(n.id, o), K(() => {
        this.personalDoc = { ...n, data: o };
      });
      return;
    }
    const l = {
      type: "personal",
      ownerUserId: i,
      wellId: e,
      lastAppliedTemplateId: null,
      templates: [t]
    }, s = await this.api.create(l);
    K(() => {
      this.personalDoc = Ne(s, l);
    });
  }
  async updateTemplateFields(e, t, n) {
    if (t === "public") {
      const s = this.publicDoc;
      if (!s || s.data.type !== "public")
        return;
      const o = {
        ...s.data,
        templates: s.data.templates.map((a) => a.id === e ? n(a) : a)
      };
      await this.api.update(s.id, o), K(() => {
        this.publicDoc = { ...s, data: o };
      });
      return;
    }
    const i = this.personalDoc;
    if (!i || i.data.type !== "personal")
      return;
    const l = {
      ...i.data,
      templates: i.data.templates.map((s) => s.id === e ? n(s) : s)
    };
    await this.api.update(i.id, l), K(() => {
      this.personalDoc = { ...i, data: l };
    });
  }
  async setLastAppliedTemplateId(e) {
    const t = this.wellsService.primaryWellId;
    if (!W(t))
      return;
    const n = this.personalDoc, i = this.getOwnerUserId();
    if (n && n.data.type === "personal") {
      const o = {
        ...n.data,
        lastAppliedTemplateId: e
      };
      await this.api.update(n.id, o), K(() => {
        this.personalDoc = { ...n, data: o };
      });
      return;
    }
    const l = {
      type: "personal",
      ownerUserId: i,
      wellId: t,
      lastAppliedTemplateId: e,
      templates: []
    }, s = await this.api.create(l);
    K(() => {
      this.personalDoc = Ne(s, l);
    });
  }
}
k([
  T.ref
], P.prototype, "publicDoc", 2);
k([
  T.ref
], P.prototype, "personalDoc", 2);
k([
  T
], P.prototype, "isLoading", 2);
k([
  T
], P.prototype, "isSaving", 2);
k([
  T
], P.prototype, "saveModalOpen", 2);
k([
  T
], P.prototype, "renameTarget", 2);
k([
  w
], P.prototype, "publicGroups", 1);
k([
  w
], P.prototype, "personalGroups", 1);
k([
  w
], P.prototype, "lastAppliedTemplateId", 1);
k([
  w
], P.prototype, "hasRestorableLastAppliedGroup", 1);
k([
  w
], P.prototype, "hasAnyGroups", 1);
k([
  w
], P.prototype, "canCreate", 1);
k([
  y.bound
], P.prototype, "openSaveModal", 1);
k([
  y.bound
], P.prototype, "closeSaveModal", 1);
k([
  y.bound
], P.prototype, "openRenameModal", 1);
k([
  y.bound
], P.prototype, "closeRenameModal", 1);
k([
  y.bound
], P.prototype, "toggleGroupFavorite", 1);
k([
  U.bound
], P.prototype, "loadTemplatesForWell", 1);
k([
  U.bound
], P.prototype, "reloadForWellChange", 1);
k([
  U.bound
], P.prototype, "createGroupFromCurrentSelection", 1);
k([
  U.bound
], P.prototype, "createGroupWithTree", 1);
k([
  U.bound
], P.prototype, "renameGroup", 1);
k([
  U.bound
], P.prototype, "updateGroupWithCurrentTree", 1);
k([
  U.bound
], P.prototype, "applyGroup", 1);
k([
  U.bound
], P.prototype, "duplicateGroup", 1);
k([
  U.bound
], P.prototype, "deleteGroup", 1);
k([
  y.bound
], P.prototype, "restoreLastApplied", 1);
export {
  te as DEFAULT_REFERENCE_WELLS_VISIBILITY,
  fn as EMPTY_REFERENCE_WELLS_FILTERS,
  Il as REFERENCE_DATA_TEMPLATES_OBJECT_TYPE,
  P as ReferenceDataTemplatesStore,
  Ee as ReferenceWellsChildrenStore,
  vl as ReferenceWellsPanel,
  A as ReferenceWellsService,
  g as ReferenceWellsStore,
  Sl as WELLBORE_TYPE_DIRECTORY_OBJECTS,
  Wl as applyDefaultPrimaryWellboreIfNoGroup,
  el as buildWellboreTypeLookup,
  rl as enrichReferenceWellChildrenByWellId,
  nl as enrichReferenceWellChildrenCatalog,
  Lt as isForcedDesign,
  Mt as isForcedFactBranch,
  He as isForcedPlanBranch,
  ze as isForcedTrajectory,
  ve as isForcedWellbore,
  Rt as isSameForcedPrimarySelection,
  _l as loadReferenceWellsSyncWithTemplates,
  me as parseVersionedReferenceWellsSettings,
  yl as parseVersionedSelectedReferenceTree,
  wl as withWellboreTypeEnrichment,
  fe as wrapVersionedSelectedReferenceTree
};
//# sourceMappingURL=reference-wells.es.js.map
